import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../style/dashboard.css';
import { useAppId } from '../context/AppIdContext';
import Header from '../component/header';
import SocialUpdate from './socialUpdate/socialUpdate';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const Dashboard = () => {

    const navigate = useNavigate();
    const {
        appId,
        total_voters,
        language,
        vidhanSabhaName,
        vidhanSabhaNo,
        userType,
        userId,
        boothNo,
        whtspApi,
        wtspDeviceId,
        aacharSahita,
        sleepSend,
        prachar,
        metaWtsp,
        setTotalVoters,
        setVidhanSabhaNo,
        setVidhanSabhaName,
        setCandidateNo,
        setCandidateName,
        setPartyShortName,
        setPartyFullName,
        setPartyLogoPng,
        setPartyLogoJpg,
        setSlipMessage,
        setSmsSlipMessage,
        setOfflineStatus,
        setOfflineDbUrl,
        setOfflineVer,
        setSplaceUrl,
        setAppLink,
        setVideoLink,
        setAppVer,
        setUserType,
        setBoothNo,
        setTempStatus,
        setPopupStatus,
        setPopupUrl,
        setCallCenter,
        setPrachar,
        setAacharSahita,
        setLiveVoting,
        setSleepSend,
        setMetaWtsp,
        setWhtspApi,
        setAi,
        setAppClose,
        setWtspDeviceId,
        setUserName,
        setUserPhoto,
        setMobileNo,
        setIsAuthenticated
    } = useAppId();

    const lang = language || 'en';



    // --- Dashboard Stats State ---
    const [dashboardStats, setDashboardStats] = useState({
        contactGroupUser: 0,
        surnameGroupUser: 0,
        memberGroupUser: 0,
        slipSendUser: 0,
        contactGroup: 0,
        surnameGroup: 0,
        myMember: 0,
        slipSend: 0,
        totalConfirmVoter: 0
    });

    // Add these states in your parent component
    const [liveVotingModal, setLiveVotingModal] = useState({
        isOpen: false,
        boothNo: null
    });
    const [voterNumber, setVoterNumber] = useState("");
    const [voterNumbersList, setVoterNumbersList] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);


    // --- ROLE VERIFICATION LOGIC ---
    const roleCode = userType?.toUpperCase() || 'A';
    const isAdmin = roleCode === 'A' || roleCode === 'ADMIN';
    const isSubAdmin = roleCode === 'SA' || roleCode === 'SUB_ADMIN';
    const isShaktiKendra = roleCode === 'SP' || roleCode === 'SHAKTI_KENDRA';
    const isBoothPramukh = roleCode === 'BP' || roleCode === 'BOOTH_PRAMUKH';
    const isSahBoothPramukh = roleCode === 'BS' || roleCode === 'SAH_BOOTH_PRAMUKH';
    const isKaryakarta = roleCode === 'K' || roleCode === 'KARYAKARTA';
    const isCallCenter = roleCode === 'CL' || roleCode === 'CALL_CENTER';
    const isVoterCaptain = roleCode === 'VC' || roleCode === 'VOTER_CAPTAIN';
    const isWarroomPramukh = roleCode === 'WP' || roleCode === 'WARROOM_PRAMUKH';
    const isBoothCaptain = roleCode === 'BC' || roleCode === 'BOOTH_CAPTAIN';
    const isLiveVotingUser = roleCode === 'LV' || roleCode === 'LIVE_VOTING';

    useEffect(() => {
        if (!appId) {
            navigate('/login')
        } else {
            fetchUserLoginData();
            fetchDashboardStats();
        }
    }, [appId, navigate]);

    // --- Fetch User Login Data API ---
    const fetchUserLoginData = async () => {
        try {
            const response = await axios.post(`${BASE_URL}/api/user_login_for_splace`, {
                app_id: appId,
                user_id: userId
            });

            if (response.data.success && response.data.data.result) {
                const result = response.data.data.result[0];

                // Update all context states with the response data
                if (result.total_voter !== undefined) setTotalVoters(result.total_voter);
                if (result.vidhansabha_no) setVidhanSabhaNo(result.vidhansabha_no);
                if (result.vidhansabha_name) setVidhanSabhaName(result.vidhansabha_name);
                if (result.candidate_no) setCandidateNo(result.candidate_no);
                if (result.candidate_name) setCandidateName(result.candidate_name);
                if (result.party_short_name) setPartyShortName(result.party_short_name);
                if (result.party_full_name) setPartyFullName(result.party_full_name);
                if (result.party_logo_png) setPartyLogoPng(result.party_logo_png);
                if (result.party_logo_jpg) setPartyLogoJpg(result.party_logo_jpg);
                if (result.slip_message) setSlipMessage(result.slip_message);
                if (result.sms_slip_message) setSmsSlipMessage(result.sms_slip_message);
                if (result.offline_status !== undefined) setOfflineStatus(result.offline_status);
                if (result.offline_db_url) setOfflineDbUrl(result.offline_db_url);
                if (result.offline_ver) setOfflineVer(result.offline_ver);
                if (result.splace_url) setSplaceUrl(result.splace_url);
                if (result.app_link) setAppLink(result.app_link);
                if (result.video_link) setVideoLink(result.video_link);
                if (result.app_ver) setAppVer(result.app_ver);
                if (result.user_type) setUserType(result.user_type);
                if (result.booth_no !== undefined) setBoothNo(result.booth_no);
                if (result.temp_status !== undefined) setTempStatus(result.temp_status);
                if (result.popup_status !== undefined) setPopupStatus(result.popup_status);
                if (result.popup_url) setPopupUrl(result.popup_url);
                if (result.name) setUserName(result.name);
                if (result.photo || result.photo_path) {
                    const photoUrl = result.photo_path || result.photo;
                    setUserPhoto(photoUrl);
                }
                if (result.mobile_no) setMobileNo(result.mobile_no);

                // Feature toggle states
                if (result.call_center !== undefined) setCallCenter(result.call_center === 1 );
                if (result.prachar !== undefined) setPrachar(result.prachar);
                if (result.aachar_sahita !== undefined) setAacharSahita(result.aachar_sahita);
                if (result.live_voting !== undefined) setLiveVoting(result.live_voting === 1);
                if (result.sleep_send !== undefined) setSleepSend(result.sleep_send);
                if (result.meta_wtsp !== undefined) setMetaWtsp(result.meta_wtsp);
                if (result.whtsp_api !== undefined) setWhtspApi(result.whtsp_api);
                if (result.AI !== undefined) setAi(result.AI === 1);
                if (result.app_close !== undefined) setAppClose(result.app_close === 1);
                if (result.wtsp_device_id !== undefined) setWtspDeviceId(result.wtsp_device_id);

                // Set authentication
                setIsAuthenticated(true);   
            }
        } catch (error) {
            console.error("Error fetching user login data:", error);
        }
    };



    // --- Fetch Dashboard Stats API ---

    const fetchDashboardStats = async () => {
        try {
            const response = await axios.post(`${BASE_URL}/api/dis_admin_dash`, {
                app_id: appId,
                user_id: userId
            });


            if (response.data.success && response.data.data) {
                const result1 = response.data.data.result?.[0] || {};
                const result2 = response.data.data.result2?.[0] || {};
                const result3 = response.data.data.result3?.[0] || {};
                setDashboardStats({
                    contactGroupUser: result1.contact_group_user || 0,
                    surnameGroupUser: result1.surname_group_user || 0,
                    memberGroupUser: result1.member_group_user || 0,
                    slipSendUser: result1.slip_send_user || 0,
                    contactGroup: result2.contact_group || 0,
                    surnameGroup: result2.surname_group || 0,
                    myMember: result2.my_member || 0,
                    slipSend: result2.slip_send || 0,
                    totalConfirmVoter: result3.total_confirm_voter || 0
                });
            }
        } catch (error) {
            console.error("Error fetching dashboard stats:", error);
        }
    };



    // Translation dictionary

    const t = {
        en: {
            totalVoters: "Voters :",
            vidhanSabha: "Vidhan Sabha :",
            cadres: "Cadres",
            reports: "Slip And Survey Report",
            communication: "Confirm Voters",
            admin: "Admin",
            subAdmin: "Sub Admin",
            shaktiKendra: "Shakti Kendra",
            boothPramukh: "Booth Pramukh",
            sahBoothPramukh: "Sah Booth Pramukh",
            volunteer: "Volunteer",
            callCenter: "Call Center",
            voterCaptain: "Voter Captain",
            warroomPramukh: "Warroom Pramukh",
            boothCaptain: "Booth Captain",
            myOrganization: "My Organization",
            myVoter: "My Voter",
            voterList: "Voter List",
            voterListSubtitle: "Search and manage voter database",
            partyCader: "Party Cader",
            personalCader: "Candidate Cader",
            bulkPrachar: "Bulk Prachar",
            beneficiary: "Beneficiary",
            liveVoting: "Live Voting",
            sangathan: "Organization",
            matdar: "Voter",
            karyakartaBP: "Volunteer",
            survey: "Survey",
            slipSendingReport: "Slip Sending Report",
            slipSendingReportSub: "Track slip distribution status",
            cadreWiseSurvey: "Survey Report",
            cadreWiseSurveySub: "View surveys by cadre",
            callCenterSurvey: "Call Center Survey",
            callCenterSurveySub: "Analyze call center performance",
            starVolunteer: "Star Volunteer",
            starVolunteerSub: "Top performing volunteers",
            pracharMaster: "Prachar Master",
            pracharMasterSub: "Manage promotional campaigns",
            bulkSlipPrint: "Bulk Slip Print",
            bulkSlipPrintSub: "Generate printable voter slips",
            mySlipSending: "My Slip Sending",
            mySlipSendingSub: "View your personal slip sending stats",
            myPhonebookSlip: "My Phonebook Slip Send",
            myPhonebookSlipSub: "Send slips to your phonebook contacts",
            myPhonebook: "My Phonebook",
            volunteerPhonebook: "Volunteer's Phonebook",
            myGroup: "My Group",
            volunteerGroup: "Volunteer's Group",
            surnameGroup: "Surname Group",
            volSurnameGroup: "Volunteer's Surname Group",
            loading: "Loading...",
            socialMedia: "Youth and Social Media Strategy",
            userManagement: "User Management",
            allUsers: "All Users",
            allUsersSub: "View and manage all registered users",
            helpVideo: "Help Video",
            helpVideoSub: "Watch tutorial videos for guidance",
            reach: "100% reach up to the voters",
            socialUpdate: "Social Update",
            mySlipSend: "My Slip Send",
            confirmVoter: "Confirm Voter",
            benefeciarySub: "Manage beneficiaries of government schemes",
            liveVotingSub: "Open live election desk",
            mySlipSendSub: "View your personal slip sending stats",
            bulkMetaSlip: "Bulk Meta Slip",
            myWallet: "My Wallet",
            bulkSlip: "Bulk Slip"
        },

        hi: {
            totalVoters: "मतदाता :",
            vidhanSabha: "विधानसभा :",
            cadres: "कार्यकर्ता",
            reports: "पर्ची और सर्वेक्षण रिपोर्ट",
            communication: "कन्फर्म मतदाता",
            admin: "एडमिन",
            subAdmin: "उप एडमिन",
            shaktiKendra: "शक्ति केंद्र",
            boothPramukh: "बूथ प्रमुख",
            sahBoothPramukh: "सह बूथ प्रमुख",
            volunteer: "कार्यकर्ता",
            callCenter: "कॉल सेंटर",
            voterCaptain: "वोटर कैप्टन",
            warroomPramukh: "वाररूम प्रमुख",
            boothCaptain: "बूथ कैप्टन",
            myOrganization: "मेरा संगठन",
            myVoter: "मेरा मतदाता",
            voterList: "मतदाता सूची",
            voterListSubtitle: "मतदाता डेटाबेस खोजें और प्रबंधित करें",
            partyCader: "पार्टी कार्यकर्ता",
            personalCader: "उमेदवार कार्यकर्ता",
            bulkPrachar: "बल्क प्रचार",
            beneficiary: "लाभार्थी",
            liveVoting: "लाइव वोटिंग",
            sangathan: "संगठन",
            matdar: "मतदाता",
            karyakartaBP: "कार्यकर्ता",
            survey: "सर्वेक्षण",
            slipSendingReport: "स्लिप भेजने की रिपोर्ट",
            slipSendingReportSub: "स्लिप वितरण की स्थिति ट्रैक करें",
            cadreWiseSurvey: "सर्वेक्षण रिपोर्ट",
            cadreWiseSurveySub: "कार्यकर्ता द्वारा सर्वेक्षण देखें",
            callCenterSurvey: "कॉल सेंटर सर्वेक्षण रिपोर्ट",
            callCenterSurveySub: "कॉल सेंटर के प्रदर्शन का विश्लेषण करें",
            starVolunteer: "स्टार कार्यकर्ता",
            starVolunteerSub: "शीर्ष प्रदर्शन करने वाले कार्यकर्ता",
            pracharMaster: "प्रचार मास्टर",
            pracharMasterSub: "प्रचार अभियानों का प्रबंधन करें",
            bulkSlipPrint: "बल्क स्लिप प्रिंट",
            bulkSlipPrintSub: "प्रिंट करने योग्य मतदाता स्लिप बनाएं",
            mySlipSending: "मेरी स्लिप भेजना",
            mySlipSendingSub: "अपनी व्यक्तिगत स्लिप भेजने के आँकड़े देखें",
            myPhonebookSlip: "मेरी फोनबुक स्लिप भेजें",
            myPhonebookSlipSub: "अपने फोनबुक संपर्कों को स्लिप भेजें",
            myPhonebook: "मेरी फोनबुक",
            volunteerPhonebook: "कार्यकर्ता की फोनबुक",
            myGroup: "मेरा समूह",
            volunteerGroup: "कार्यकर्ता का समूह",
            surnameGroup: "उपनाम समूह",
            volSurnameGroup: "स्व. उपनाम समूह",
            loading: "लोड हो रहा है...",
            socialMedia: "युवा और सोशल मीडिया रणनीति",
            userManagement: "उपयोगकर्ता प्रबंधन",
            allUsers: "सभी उपयोगकर्ता",
            allUsersSub: "सभी पंजीकृत उपयोगकर्ताओं को देखें और प्रबंधित करें",
            helpVideo: "सहायता वीडियो",
            helpVideoSub: "मार्गदर्शन के लिए ट्यूटोरियल वीडियो देखें",
            reach: "मतदाताओं तक 100% पहुंच",
            socialUpdate: "सोशल अपडेट",
            mySlipSend: "मेरी स्लिप भेजें",
            confirmVoter: "कन्फर्म मतदाता",
            benefeciarySub: "सरकारी योजनाओं के लाभार्थी का प्रबंधन करें",
            liveVotingSub: "खुला लाइव वोटिंग डेस्क",
            mySlipSendSub: "अपनी व्यक्तिगत स्लिप भेजने के आँकड़े देखें",
            bulkMetaSlip: "बल्क मेटा स्लिप",
            myWallet: "मेरा वॉलेट",
            bulkSlip: "बल्क स्लिप"
        },
        gu: {
            totalVoters: "મતદારો :",
            vidhanSabha: "વિધાનસભા :",
            cadres: "કાર્યકર્તાઓ",
            reports: "સ્લિપ અને સર્વે રિપોર્ટ",
            communication: "કન્ફોર્મ મતદારો",
            admin: "એડમિન",
            subAdmin: "સબ એડમિન",
            shaktiKendra: "શક્તિ કેન્દ્ર",
            boothPramukh: "બૂથ પ્રમુખ",
            sahBoothPramukh: "સહ બૂથ પ્રમુખ",
            volunteer: "સ્વયંસેવક",
            callCenter: "કૉલ સેન્ટર",
            voterCaptain: "વોટર કેપ્ટન",
            warroomPramukh: "વોરરૂમ પ્રમુખ",
            boothCaptain: "બૂથ કેપ્ટન",
            myOrganization: "મારું સંગઠન",
            myVoter: "મારા મતદાર",
            voterList: "મતદાર યાદી",
            voterListSubtitle: "મતદાર ડેટાબેઝ શોધો અને સંચાલિત કરો",
            partyCader: "પાર્ટી કેડર",
            personalCader: "ઉમેદવાર કેડર",
            bulkPrachar: "બલ્ક પ્રચાર",
            beneficiary: "યોજનાઓના લાભાર્થી",
            liveVoting: "લાઇવ મતદાન",
            sangathan: "સંગઠન",
            matdar: "મતદાર",
            karyakartaBP: "કાર્યકર્તા",
            survey: "સર્વે",
            slipSendingReport: "સ્લિપ પ્રચાર રિપોર્ટ",
            slipSendingReportSub: "સ્લિપ વિતરણ સ્થિતિ ટ્રૅક કરો",
            cadreWiseSurvey: "સર્વે રિપોર્ટ",
            cadreWiseSurveySub: "કાર્યકર દ્વારા સર્વેક્ષણો જુઓ",
            callCenterSurvey: "કૉલ સેન્ટર સર્વે રિપોર્ટ",
            callCenterSurveySub: "કૉલ સેન્ટર કામગીરીનું વિશ્લેષણ કરો",
            starVolunteer: "સ્ટાર કાર્યકર્તા",
            starVolunteerSub: "શ્રેષ્ઠ પ્રદર્શન કરનારા સ્વયંસેવકો",
            pracharMaster: "પ્રચાર માસ્ટર",
            pracharMasterSub: "પ્રમોશનલ ઝુંબેશનું સંચાલન કરો",
            bulkSlipPrint: "બલ્ક સ્લિપ પ્રિન્ટ",
            bulkSlipPrintSub: "છાપવા યોગ્ય મતદાર સ્લિપ બનાવો",
            mySlipSending: "મારી સ્લિપ મોકલવી",
            mySlipSendingSub: "તમારા વ્યક્તિગત સ્લિપ મોકલવાના આંકડા જુઓ",
            myPhonebookSlip: "મારી ફોનબુક સ્લિપ મોકલો",
            myPhonebookSlipSub: "તમારા ફોનબુક સંપર્કોને સ્લિપ મોકલો",
            myPhonebook: "મારી ફોનબુક",
            volunteerPhonebook: "કાર્યકર્તાની ફોનબુક",
            myGroup: "મારા મતદાર",
            volunteerGroup: "કાર્યકર્તા ના મતદાર",
            surnameGroup: "સરનેમ ગ્રુપ",
            volSurnameGroup: "કાર્યકર્તાના સરનેમ ગ્રુપ",
            loading: "લોડ થઈ રહ્યું છે...",
            socialMedia: "યુવા અને સોશિયલ મીડિયા ની રણનીતિ",
            userManagement: "યુઝર મેનેજમેન્ટ",
            allUsers: "બધા યુઝર્સ",
            allUsersSub: "તમામ નોંધાયેલા યુઝર્સ જુઓ અને મેનેજ કરો",
            helpVideo: "હેલ્પ વિડિયો",
            helpVideoSub: "માર્ગદર્શન માટે ટ્યુટોરિયલ વિડિયો જુઓ",
            reach: "100% મતદારો સુધી પહોંચવું",
            socialUpdate: "સોશિયલ અપડેટ",
            mySlipSend: "મારી સ્લિપ",
            confirmVoter: "કન્ફર્મ મતદાર",
            benefeciarySub: "સરકારી યોજનાઓના લાભાર્થીનું સંચાલન કરો",
            liveVotingSub: "લાઇવ ચૂંટણી ડેસ્ક ખોલો",
            mySlipSendSub: "તમારા વ્યક્તિગત સ્લિપ મોકલવાના આંકડા જુઓ",
            bulkMetaSlip: "બલ્ક મેટા સ્લિપ",
            myWallet: "મારું વૉલેટ",
            bulkSlip: "બલ્ક સ્લિપ"
        }
    };
    const txt = t[lang];

    const handleNavigate = (path) => {
        navigate(path);
    };



    return (
        <div className="app-container dashboard-page">
            <div className="dashboard-content container-fluid p-4">

                <Header title="Dashboard" />

                {/* Info Card Animation */}
                <div className="info-card mb-4 slide-up-element" style={{ animationDelay: '0.1s' }}>
                    <div className="info-card-content">
                        <div className="info-item">
                            <span className="info-name">{vidhanSabhaNo && (<><span className="info-name"> {vidhanSabhaNo}</span></>)} : {vidhanSabhaName}</span>
                        </div>
                        <div className="info-divider"></div>
                        <div className="info-item">
                            <div className="info-value-group">
                                <span className="info-number-large">{txt.totalVoters}</span>  <span className="info-number-large">{total_voters?.toLocaleString()}</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Booth Captain Section */}
                {isBoothCaptain && (
                    <>
                        {/* Cadres Section for Booth Captain */}
                        <div className="section-card mb-4 p-0 fade-in-up" style={{ backgroundColor: '#ffffff', animationDelay: '0.2s' }}>
                            <div className="p-3 d-flex align-items-center border-bottom" style={{ borderColor: '#e2e8f0' }}>
                                <div className="section-icon-bg bg-white mr-2" style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
                                    <span className="emoji-icon">👥</span>
                                </div>
                                <h5 className="mb-0 font-weight-bold" style={{ color: '#1e40af' }}>{txt.cadres}</h5>
                            </div>
                            <div className="row g-4 p-3 m-0" style={{ marginTop: '0px', paddingTop: '16px' }}>
                                <DashboardCard title={txt.myOrganization} icon={<ThreePeopleIcon color="currentColor" />} color="#2563eb" delay="0.25s" onClick={() => navigate('/dis_booth_captain_cadre_with_voter', { state: { boothId: boothNo } })} />
                                <DashboardCard title={txt.myVoter} icon={<ThreePeopleIcon color="currentColor" />} color="#f97316" delay="0.3s" onClick={() => handleNavigate('/voter')} />
                                <DashboardCard title={txt.volunteer} icon={<MultiPeopleIcon />} color="#ec4899" delay="0.35s" onClick={() => handleNavigate('/display_karyakarta')} />
                            </div>
                        </div>

                        {/* Voter List Banner Animation - White Background */}
                        <div className="row mb-4 fade-in-up" style={{ animationDelay: '0.45s' }}>
                            <div className="col-12">
                                <div className="section-card voter-search-card" onClick={() => handleNavigate('/voter_list')} style={{ background: '#ffffff', padding: '16px 20px' }}>
                                    <div className="voter-icon-circle" style={{ background: '#f1f5f9' }}>
                                        <svg width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>
                                    </div>
                                    <div className="voter-text">
                                        <h3>{txt.voterList}</h3>
                                    </div>
                                    <div className="voter-count-display">
                                        <span className="voter-count-label">{txt.totalVoters}</span>
                                        <span className="voter-count-number">{total_voters?.toLocaleString()}</span>
                                    </div>
                                    <div className="arrow-icon">
                                        <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" /></svg>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Confirm Voters Section Wrapped with Animation - Only My Phonebook, My Group, My Surname Group for Shakti Kendra */}
                        <div className="section-card mb-4 p-0 fade-in-up " style={{ backgroundColor: '#ffffff', animationDelay: '0.5s' }}>
                            <div className="p-3 d-flex align-items-center border-bottom" style={{ borderColor: '#e2e8f0' }}>
                                <div className="section-icon-bg bg-white me-2" style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
                                    <span className="emoji-icon">✔️</span>
                                </div>
                                <h5 className="mb-0 font-weight-bold me-2" style={{ color: '#0f172a' }}>{txt.communication}</h5>
                                <div className="d-flex align-items-center ml-auto">
                                    <div className="arrow-right text-muted"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#64748b" strokeWidth="2"><path d="M9 5l7 7-7 7" /></svg></div>
                                </div>
                            </div>
                            <div className="row g-4 p-3 m-0" style={{ marginTop: '0px', paddingTop: '16px' }}>
                                {/* Only My Phonebook - No Volunteer Phonebook */}
                                <div className="col-12 col-md-6 col-lg-4 fade-in-up mt-2 mb-2" style={{ animationDelay: '0.55s' }}>
                                    <div className="single-card">
                                        <div className="single-row" onClick={() => handleNavigate('/dis_contact_group_member')}>
                                            <span className="list-icon">📖</span>
                                            <span className="list-title">{txt.myPhonebook}</span>
                                            <span className="list-count">{dashboardStats.contactGroup}</span>
                                            <svg className="list-arrow" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                                {/* Only My Surname Group - No Volunteer Surname Group */}
                                <div className="col-12 col-md-6 col-lg-4 fade-in-up mt-2 mb-2" style={{ animationDelay: '0.6s' }}>
                                    <div className="single-card">
                                        <div className="single-row" onClick={() => handleNavigate('/dis_surname_group')}>
                                            <span className="list-icon">👪</span>
                                            <span className="list-title">{txt.surnameGroup}</span>
                                            <span className="list-count">{dashboardStats.surnameGroup}</span>
                                            <svg className="list-arrow" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>

                                {/* Only My Group - No Volunteer Group */}
                                <div className="col-12 col-md-6 col-lg-4 fade-in-up mt-2 mb-2" style={{ animationDelay: '0.65s' }}>
                                    <div className="single-card">
                                        <div className="single-row" onClick={() => handleNavigate('/dis_my_group_member')}>
                                            <span className="list-icon">👥</span>
                                            <span className="list-title">{txt.myGroup}</span>
                                            <span className="list-count">{dashboardStats.myMember}</span>
                                            <svg className="list-arrow" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>

                                {/* My Slip Send - New Card Added */}
                                <div className="col-12 col-md-6 col-lg-4 fade-in-up mt-2 mb-2" style={{ animationDelay: '0.7s' }}>
                                    <div className="single-card">
                                        <div className="single-row" onClick={() => handleNavigate('/dis_my_slip_sending_voter')}>
                                            <span className="list-icon">📨</span>
                                            <span className="list-title">{txt.mySlipSend}</span>
                                            <span className="list-count">{dashboardStats.slipSend}</span>
                                            <svg className="list-arrow" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Beneficiary & Live Voting Animation */}

                        <div className="row g-4 mb-5 fade-in-up" style={{ animationDelay: '0.85s' }}>
                            <HorizontalFeatureCard title={txt.beneficiary} subtitle={txt.benefeciarySub} icon={<GiftIcon />} iconBgColor="#f43f5e" subtitleColor="#e11d48" delay="0.85s" onClick={() => handleNavigate('/beneficiary')} />
                            <HorizontalFeatureCard title={txt.liveVoting} subtitle={txt.liveVotingSub} icon={<ChartBarIcon />} iconBgColor="#10b981" subtitleColor="#059669" delay="0.9s" onClick={() => handleNavigate('/live_Voting_cader')} />
                        </div>

                        {/* Reports Section Wrapped with Animation */}
                        <div className="section-card bg-gray mb-4 p-0 fade-in-up" style={{ backgroundColor: '#ffffff', animationDelay: '0.8s' }}>
                            <div className="p-3 d-flex align-items-center border-bottom" style={{ borderColor: '#e2e8f0' }}>
                                <div className="section-icon-bg bg-white mr-2" style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
                                    <span className="emoji-icon">📊</span>
                                </div>
                                <h5 className="mb-0 font-weight-bold" style={{ color: '#0f172a' }}>{txt.reports}</h5>
                            </div>
                            <div className="row g-4 p-3 m-0">
                                <ModernReportCard title={txt.slipSendingReport} subtitle={txt.slipSendingReportSub} icon={<ReportIcon />} color="#22c55e" delay="0.85s" onClick={() => { handleNavigate('/get_total_slip_distribution_count') }} />
                                <ModernReportCard title={txt.survey} subtitle={txt.cadreWiseSurveySub} icon={<SurveyIcon />} color="#f97316" delay="0.9s" onClick={() => { handleNavigate('/booth_pramukha_survey_dash') }} />
                            </div>
                        </div>

                        {/* Social Media Section with Animation - Mobile Responsive */}
                        <div className="section-card bg-gray border-0 p-0 fade-in-up" style={{ background: 'linear-gradient(120deg, #1e3a8a 0%, #3b82f6 100%)', animationDelay: '1.0s' }}>
                            <div className="p-3 d-flex align-items-center border-bottom" style={{ borderColor: 'rgba(255,255,255,0.2)' }}>
                                <div className="section-icon-bg bg-white me-2" style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
                                    <span className="emoji-icon">📱</span>
                                </div>
                                <h5 className="mb-0 font-weight-bold" style={{ color: '#ffffff' }}>{txt.socialMedia}</h5>
                            </div>
                            <div className='row g-4 p-3 m-0 social-row'>
                                <ModernReportCard title={txt.socialUpdate} subtitle={txt.socialUpdate} icon={<HeadsetReportIcon />} color="#ec4899" delay="1.15s" onClick={() => { handleNavigate('/display_posts') }} />
                                {/* Help Video Card */}
                                <div className="col-12 col-md-6 fade-in-up mt-2 mb-2" style={{ animationDelay: '1.3s' }}>
                                    <div className="user-management-card" onClick={() => handleNavigate('/video_help')}>
                                        <div className="um-icon-wrapper" style={{ backgroundColor: '#10b981', color: 'white' }}>
                                            <svg width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                                            </svg>
                                        </div>
                                        <div className="um-text-wrapper">
                                            <h5 className="um-title">{txt.helpVideo}</h5>
                                            <p className="um-subtitle">{txt.helpVideoSub}</p>
                                        </div>
                                        <div className="um-arrow">
                                            <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}

                {/* Warroom Pramukh Section */}
                {isWarroomPramukh && (
                    <>
                        {/* Cadres Section for Warroom Pramukh */}
                        <div className="section-card mb-4 p-0 fade-in-up" style={{ backgroundColor: '#ffffff', animationDelay: '0.2s' }}>
                            <div className="p-3 d-flex align-items-center border-bottom" style={{ borderColor: '#e2e8f0' }}>
                                <div className="section-icon-bg bg-white mr-2" style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
                                    <span className="emoji-icon">👥</span>
                                </div>
                                <h5 className="mb-0 font-weight-bold" style={{ color: '#1e40af' }}>{txt.cadres}</h5>
                            </div>
                            <div className="row g-4 p-3 m-0" style={{ marginTop: '0px', paddingTop: '16px' }}>
                                <DashboardCard title={txt.myOrganization} icon={<ThreePeopleIcon color="currentColor" />} color="#2563eb" delay="0.25s" onClick={() => handleNavigate('/dis_booth_captain')} />
                                <DashboardCard title={txt.myVoter} icon={<ThreePeopleIcon color="currentColor" />} color="#f97316" delay="0.3s" onClick={() => handleNavigate('/shakti_kendra_voter')} />
                                <DashboardCard title={txt.volunteer} icon={<MultiPeopleIcon />} color="#ec4899" delay="0.35s" onClick={() => handleNavigate('/display_karyakarta')} />
                            </div>
                        </div>
                        {/* Voter List Banner Animation - White Background */}
                        <div className="row mb-4 fade-in-up" style={{ animationDelay: '0.45s' }}>
                            <div className="col-12">
                                <div className="section-card voter-search-card" onClick={() => handleNavigate('/voter_list')} style={{ background: '#ffffff', padding: '16px 20px' }}>
                                    <div className="voter-icon-circle" style={{ background: '#f1f5f9' }}>
                                        <svg width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>
                                    </div>
                                    <div className="voter-text">
                                        <h3>{txt.voterList}</h3>
                                    </div>
                                    <div className="voter-count-display">
                                        <span className="voter-count-label">{txt.totalVoters}</span>
                                        <span className="voter-count-number">{total_voters?.toLocaleString()}</span>
                                    </div>
                                    <div className="arrow-icon">
                                        <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" /></svg>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Confirm Voters Section Wrapped with Animation - Only My Phonebook, My Group, My Surname Group for Shakti Kendra */}
                        <div className="section-card mb-4 p-0 fade-in-up " style={{ backgroundColor: '#ffffff', animationDelay: '0.5s' }}>
                            <div className="p-3 d-flex align-items-center border-bottom" style={{ borderColor: '#e2e8f0' }}>
                                <div className="section-icon-bg bg-white me-2" style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
                                    <span className="emoji-icon">✔️</span>
                                </div>
                                <h5 className="mb-0 font-weight-bold me-2" style={{ color: '#0f172a' }}>{txt.communication}</h5>
                                <div className="d-flex align-items-center ml-auto">
                                    <div className="arrow-right text-muted"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#64748b" strokeWidth="2"><path d="M9 5l7 7-7 7" /></svg></div>
                                </div>
                            </div>
                            <div className="row g-4 p-3 m-0" style={{ marginTop: '0px', paddingTop: '16px' }}>
                                {/* Only My Phonebook - No Volunteer Phonebook */}
                                <div className="col-12 col-md-6 col-lg-4 fade-in-up mt-2 mb-2" style={{ animationDelay: '0.55s' }}>
                                    <div className="single-card">
                                        <div className="single-row" onClick={() => handleNavigate('/dis_contact_group_member')}>
                                            <span className="list-icon">📖</span>
                                            <span className="list-title">{txt.myPhonebook}</span>
                                            <span className="list-count">{dashboardStats.contactGroup}</span>
                                            <svg className="list-arrow" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>

                                {/* Only My Surname Group - No Volunteer Surname Group */}
                                <div className="col-12 col-md-6 col-lg-4 fade-in-up mt-2 mb-2" style={{ animationDelay: '0.6s' }}>
                                    <div className="single-card">
                                        <div className="single-row" onClick={() => handleNavigate('/dis_surname_group')}>
                                            <span className="list-icon">👪</span>
                                            <span className="list-title">{txt.surnameGroup}</span>
                                            <span className="list-count">{dashboardStats.surnameGroup}</span>
                                            <svg className="list-arrow" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>

                                {/* Only My Group - No Volunteer Group */}
                                <div className="col-12 col-md-6 col-lg-4 fade-in-up mt-2 mb-2" style={{ animationDelay: '0.65s' }}>
                                    <div className="single-card">
                                        <div className="single-row" onClick={() => handleNavigate('/dis_my_group_member')}>
                                            <span className="list-icon">👥</span>
                                            <span className="list-title">{txt.myGroup}</span>
                                            <span className="list-count">{dashboardStats.myMember}</span>
                                            <svg className="list-arrow" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>

                                {/* My Slip Send - New Card Added */}
                                <div className="col-12 col-md-6 col-lg-4 fade-in-up mt-2 mb-2" style={{ animationDelay: '0.7s' }}>
                                    <div className="single-card">
                                        <div className="single-row" onClick={() => handleNavigate('/dis_my_slip_sending_voter')}>
                                            <span className="list-icon">📨</span>
                                            <span className="list-title">{txt.mySlipSend}</span>
                                            <span className="list-count">{dashboardStats.slipSend}</span>
                                            <svg className="list-arrow" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Beneficiary & Live Voting Animation */}
                        <div className="row g-4 mb-5 fade-in-up" style={{ animationDelay: '0.85s' }}>
                            <HorizontalFeatureCard title={txt.beneficiary} subtitle={txt.benefeciarySub} icon={<GiftIcon />} iconBgColor="#f43f5e" subtitleColor="#e11d48" delay="0.85s" onClick={() => handleNavigate('/beneficiary')} />
                            <HorizontalFeatureCard title={txt.liveVoting} subtitle={txt.liveVotingSub} icon={<ChartBarIcon />} iconBgColor="#10b981" subtitleColor="#059669" delay="0.9s" onClick={() => handleNavigate('/live_Voting_cader')} />
                        </div>

                        {/* Reports Section Wrapped with Animation */}
                        <div className="section-card bg-gray mb-4 p-0 fade-in-up" style={{ backgroundColor: '#ffffff', animationDelay: '0.8s' }}>
                            <div className="p-3 d-flex align-items-center border-bottom" style={{ borderColor: '#e2e8f0' }}>
                                <div className="section-icon-bg bg-white mr-2" style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
                                    <span className="emoji-icon">📊</span>
                                </div>
                                <h5 className="mb-0 font-weight-bold" style={{ color: '#0f172a' }}>{txt.reports}</h5>
                            </div>

                            <div className="row g-4 p-3 m-0">

                                <ModernReportCard title={txt.slipSendingReport} subtitle={txt.slipSendingReportSub} icon={<ReportIcon />} color="#22c55e" delay="0.85s" onClick={() => { handleNavigate('/get_total_slip_distribution_count') }} />

                                <ModernReportCard title={txt.survey} subtitle={txt.cadreWiseSurveySub} icon={<SurveyIcon />} color="#f97316" delay="0.9s" onClick={() => { handleNavigate('/shakti_kendra_survey_dash') }} />

                            </div>

                        </div>



                        {/* Social Media Section with Animation - Mobile Responsive */}

                        <div className="section-card bg-gray border-0 p-0 fade-in-up" style={{ background: 'linear-gradient(120deg, #1e3a8a 0%, #3b82f6 100%)', animationDelay: '1.0s' }}>

                            <div className="p-3 d-flex align-items-center border-bottom" style={{ borderColor: 'rgba(255,255,255,0.2)' }}>

                                <div className="section-icon-bg bg-white me-2" style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>

                                    <span className="emoji-icon">📱</span>

                                </div>

                                <h5 className="mb-0 font-weight-bold" style={{ color: '#ffffff' }}>{txt.socialMedia}</h5>

                            </div>

                            <div className='row g-4 p-3 m-0 social-row'>

                                <ModernReportCard title={txt.socialUpdate} subtitle={txt.socialUpdate} icon={<HeadsetReportIcon />} color="#ec4899" delay="1.15s" onClick={() => { handleNavigate('/display_posts') }} />

                                {/* Help Video Card */}

                                <div className="col-12 col-md-6 fade-in-up mt-2 mb-2" style={{ animationDelay: '1.3s' }}>

                                    <div className="user-management-card" onClick={() => handleNavigate('/video_help')}>

                                        <div className="um-icon-wrapper" style={{ backgroundColor: '#10b981', color: 'white' }}>

                                            <svg width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">

                                                <path strokeLinecap="round" strokeLinejoin="round" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />

                                            </svg>

                                        </div>

                                        <div className="um-text-wrapper">

                                            <h5 className="um-title">{txt.helpVideo}</h5>

                                            <p className="um-subtitle">{txt.helpVideoSub}</p>

                                        </div>

                                        <div className="um-arrow">

                                            <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">

                                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />

                                            </svg>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </>

                )}

                {isLiveVotingUser && (
                    <>
                        {/* Live Voting User Section */}
                        {/* My Booth Section - Display all booths from boothNo with Live Voting */}
                        {boothNo && (
                            <div className="my-booth-section mb-4 slide-up-element" style={{ animationDelay: '0.12s' }}>
                                <div className="section-card p-0 fade-in-up" style={{ backgroundColor: '#ffffff' }}>
                                    <div className="p-3 d-flex align-items-center border-bottom" style={{ borderColor: '#e2e8f0' }}>
                                        <div className="section-icon-bg bg-white me-2" style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
                                            <span className="emoji-icon">🗳️</span>
                                        </div>
                                        <h5 className="mb-0 font-weight-bold" style={{ color: '#1e40af' }}>Live Voting</h5>
                                    </div>
                                    <div className="p-3">
                                        <div className="row g-3">
                                            {boothNo.split(',').filter(booth => booth.trim()).map((booth, index) => (
                                                <LiveVotingCard
                                                    key={index}
                                                    booth={booth.trim()}
                                                    appId={appId}
                                                    userId={userId}
                                                    txt={txt}
                                                    navigate={navigate}
                                                />
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </>
                )}

                {isVoterCaptain && (

                    <>

                        {/* Cadres Section for Voter Captain */}

                        <div className="section-card mb-4 p-0 fade-in-up" style={{ backgroundColor: '#ffffff', animationDelay: '0.2s' }}>

                            <div className="p-3 d-flex align-items-center border-bottom" style={{ borderColor: '#e2e8f0' }}>

                                <div className="section-icon-bg bg-white mr-2" style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>

                                    <span className="emoji-icon">👥</span>

                                </div>

                                <h5 className="mb-0 font-weight-bold" style={{ color: '#1e40af' }}>{txt.cadres}</h5>

                            </div>

                            <div className="row g-4 p-3 m-0" style={{ marginTop: '0px', paddingTop: '16px' }}>

                                <DashboardCard title={txt.myVoter} icon={<ThreePeopleIcon color="currentColor" />} color="#2563eb" delay="0.25s" onClick={() => handleNavigate('/dis_voter_captain_voter')} />



                            </div>

                        </div>



                        {/* Voter List Banner Animation - White Background */}

                        <div className="row mb-4 fade-in-up" style={{ animationDelay: '0.45s' }}>

                            <div className="col-12">

                                <div className="section-card voter-search-card" onClick={() => handleNavigate('/voter_list')} style={{ background: '#ffffff', padding: '16px 20px' }}>

                                    <div className="voter-icon-circle" style={{ background: '#f1f5f9' }}>

                                        <svg width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>

                                    </div>

                                    <div className="voter-text">

                                        <h3>{txt.voterList}</h3>



                                    </div>

                                    <div className="voter-count-display">

                                        <span className="voter-count-label">{txt.totalVoters}</span>

                                        <span className="voter-count-number">{total_voters?.toLocaleString()}</span>

                                    </div>

                                    <div className="arrow-icon">

                                        <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" /></svg>

                                    </div>

                                </div>

                            </div>

                        </div>


                        {/* Confirm Voters Section Wrapped with Animation - Only My Phonebook, My Group, My Surname Group for Shakti Kendra */}

                        <div className="section-card mb-4 p-0 fade-in-up " style={{ backgroundColor: '#ffffff', animationDelay: '0.5s' }}>

                            <div className="p-3 d-flex align-items-center border-bottom" style={{ borderColor: '#e2e8f0' }}>

                                <div className="section-icon-bg bg-white me-2" style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>

                                    <span className="emoji-icon">✔️</span>

                                </div>

                                <h5 className="mb-0 font-weight-bold me-2" style={{ color: '#0f172a' }}>{txt.communication}</h5>

                                <div className="d-flex align-items-center ml-auto">



                                    <div className="arrow-right text-muted"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#64748b" strokeWidth="2"><path d="M9 5l7 7-7 7" /></svg></div>

                                </div>

                            </div>

                            <div className="row g-4 p-3 m-0" style={{ marginTop: '0px', paddingTop: '16px' }}>

                                {/* Only My Phonebook - No Volunteer Phonebook */}

                                <div className="col-12 col-md-6 col-lg-4 fade-in-up mt-2 mb-2" style={{ animationDelay: '0.55s' }}>

                                    <div className="single-card">

                                        <div className="single-row" onClick={() => handleNavigate('/dis_contact_group_member')}>

                                            <span className="list-icon">📖</span>

                                            <span className="list-title">{txt.myPhonebook}</span>

                                            <span className="list-count">{dashboardStats.contactGroup}</span>

                                            <svg className="list-arrow" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">

                                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />

                                            </svg>

                                        </div>

                                    </div>

                                </div>



                                {/* Only My Surname Group - No Volunteer Surname Group */}

                                <div className="col-12 col-md-6 col-lg-4 fade-in-up mt-2 mb-2" style={{ animationDelay: '0.6s' }}>

                                    <div className="single-card">

                                        <div className="single-row" onClick={() => handleNavigate('/dis_surname_group')}>

                                            <span className="list-icon">👪</span>

                                            <span className="list-title">{txt.surnameGroup}</span>

                                            <span className="list-count">{dashboardStats.surnameGroup}</span>

                                            <svg className="list-arrow" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">

                                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />

                                            </svg>

                                        </div>

                                    </div>

                                </div>



                                {/* Only My Group - No Volunteer Group */}

                                <div className="col-12 col-md-6 col-lg-4 fade-in-up mt-2 mb-2" style={{ animationDelay: '0.65s' }}>

                                    <div className="single-card">

                                        <div className="single-row" onClick={() => handleNavigate('/dis_my_group_member')}>

                                            <span className="list-icon">👥</span>

                                            <span className="list-title">{txt.myGroup}</span>

                                            <span className="list-count">{dashboardStats.myMember}</span>

                                            <svg className="list-arrow" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">

                                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />

                                            </svg>

                                        </div>

                                    </div>

                                </div>



                                {/* My Slip Send - New Card Added */}

                                <div className="col-12 col-md-6 col-lg-4 fade-in-up mt-2 mb-2" style={{ animationDelay: '0.7s' }}>

                                    <div className="single-card">

                                        <div className="single-row" onClick={() => handleNavigate('/dis_my_slip_sending_voter')}>

                                            <span className="list-icon">📨</span>

                                            <span className="list-title">{txt.mySlipSend}</span>

                                            <span className="list-count">{dashboardStats.slipSend}</span>

                                            <svg className="list-arrow" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">

                                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />

                                            </svg>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>





                        {/* Beneficiary & Live Voting Animation */}

                        <div className="row g-4 mb-5 fade-in-up" style={{ animationDelay: '0.85s' }}>

                            <HorizontalFeatureCard title={txt.beneficiary} subtitle={txt.benefeciarySub} icon={<GiftIcon />} iconBgColor="#f43f5e" subtitleColor="#e11d48" delay="0.85s" onClick={() => handleNavigate('/beneficiary')} />

                            <HorizontalFeatureCard title={txt.liveVoting} subtitle={txt.liveVotingSub} icon={<ChartBarIcon />} iconBgColor="#10b981" subtitleColor="#059669" delay="0.9s" onClick={() => handleNavigate('/live_Voting_cader')} />

                        </div>



                        {/* Reports Section Wrapped with Animation */}

                        <div className="section-card bg-gray mb-4 p-0 fade-in-up" style={{ backgroundColor: '#ffffff', animationDelay: '0.8s' }}>

                            <div className="p-3 d-flex align-items-center border-bottom" style={{ borderColor: '#e2e8f0' }}>

                                <div className="section-icon-bg bg-white mr-2" style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>

                                    <span className="emoji-icon">📊</span>

                                </div>

                                <h5 className="mb-0 font-weight-bold" style={{ color: '#0f172a' }}>{txt.reports}</h5>

                            </div>

                            <div className="row g-4 p-3 m-0">

                                <ModernReportCard title={txt.slipSendingReport} subtitle={txt.slipSendingReportSub} icon={<ReportIcon />} color="#22c55e" delay="0.85s" onClick={() => { handleNavigate('/get_total_slip_distribution_count') }} />

                                <ModernReportCard title={txt.survey} subtitle={txt.cadreWiseSurveySub} icon={<SurveyIcon />} color="#f97316" delay="0.9s" onClick={() => { handleNavigate('/dis_survey_dash_for_admin') }} />

                            </div>

                        </div>



                        {/* Social Media Section with Animation - Mobile Responsive */}

                        <div className="section-card bg-gray border-0 p-0 fade-in-up" style={{ background: 'linear-gradient(120deg, #1e3a8a 0%, #3b82f6 100%)', animationDelay: '1.0s' }}>

                            <div className="p-3 d-flex align-items-center border-bottom" style={{ borderColor: 'rgba(255,255,255,0.2)' }}>

                                <div className="section-icon-bg bg-white me-2" style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>

                                    <span className="emoji-icon">📱</span>

                                </div>

                                <h5 className="mb-0 font-weight-bold" style={{ color: '#ffffff' }}>{txt.socialMedia}</h5>

                            </div>

                            <div className='row g-4 p-3 m-0 social-row'>

                                <ModernReportCard title={txt.socialUpdate} subtitle={txt.socialUpdate} icon={<HeadsetReportIcon />} color="#ec4899" delay="1.15s" onClick={() => { handleNavigate('/display_posts') }} />

                                {/* Help Video Card */}

                                <div className="col-12 col-md-6 fade-in-up mt-2 mb-2" style={{ animationDelay: '1.3s' }}>

                                    <div className="user-management-card" onClick={() => handleNavigate('/video_help')}>

                                        <div className="um-icon-wrapper" style={{ backgroundColor: '#10b981', color: 'white' }}>

                                            <svg width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">

                                                <path strokeLinecap="round" strokeLinejoin="round" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />

                                            </svg>

                                        </div>

                                        <div className="um-text-wrapper">

                                            <h5 className="um-title">{txt.helpVideo}</h5>

                                            <p className="um-subtitle">{txt.helpVideoSub}</p>

                                        </div>

                                        <div className="um-arrow">

                                            <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">

                                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />

                                            </svg>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </>

                )}



                {isKaryakarta && (

                    <>

                        {/* Voter List Banner Animation - White Background */}

                        <div className="row mb-4 fade-in-up" style={{ animationDelay: '0.3s' }}>

                            <div className="col-12">

                                <div className="section-card voter-search-card" onClick={() => handleNavigate('/voter_list')} style={{ background: '#ffffff', padding: '16px 20px' }}>

                                    <div className="voter-icon-circle" style={{ background: '#f1f5f9' }}>

                                        <svg width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>

                                    </div>

                                    <div className="voter-text">

                                        <h3>{txt.voterList}</h3>



                                    </div>

                                    <div className="voter-count-display">

                                        <span className="voter-count-label">{txt.totalVoters}</span>

                                        <span className="voter-count-number">{total_voters?.toLocaleString()}</span>

                                    </div>

                                    <div className="arrow-icon">

                                        <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" /></svg>

                                    </div>

                                </div>

                            </div>

                        </div>



                        {/* Beneficiary & Live Voting Animation */}

                        <div className="row g-4 mb-5 fade-in-up" style={{ animationDelay: '0.85s' }}>

                            <HorizontalFeatureCard title={txt.beneficiary} subtitle={txt.benefeciarySub} icon={<GiftIcon />} iconBgColor="#f43f5e" subtitleColor="#e11d48" delay="0.85s" onClick={() => handleNavigate('/beneficiary')} />

                            <HorizontalFeatureCard title={txt.liveVoting} subtitle={txt.liveVotingSub} icon={<ChartBarIcon />} iconBgColor="#10b981" subtitleColor="#059669" delay="0.9s" onClick={() => handleNavigate('/live_Voting_cader')} />

                        </div>



                        {/* Confirm Voters Section Wrapped with Animation - Only My Phonebook, My Group, My Surname Group for Shakti Kendra */}

                        <div className="section-card mb-4 p-0 fade-in-up " style={{ backgroundColor: '#ffffff', animationDelay: '0.5s' }}>

                            <div className="p-3 d-flex align-items-center border-bottom" style={{ borderColor: '#e2e8f0' }}>

                                <div className="section-icon-bg bg-white me-2" style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>

                                    <span className="emoji-icon">✔️</span>

                                </div>

                                <h5 className="mb-0 font-weight-bold me-2" style={{ color: '#0f172a' }}>{txt.communication}</h5>

                                <div className="d-flex align-items-center ml-auto">



                                    <div className="arrow-right text-muted"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#64748b" strokeWidth="2"><path d="M9 5l7 7-7 7" /></svg></div>

                                </div>

                            </div>

                            <div className="row g-4 p-3 m-0" style={{ marginTop: '0px', paddingTop: '16px' }}>

                                {/* Only My Phonebook - No Volunteer Phonebook */}

                                <div className="col-12 col-md-6 col-lg-4 fade-in-up mt-2 mb-2" style={{ animationDelay: '0.55s' }}>

                                    <div className="single-card">

                                        <div className="single-row" onClick={() => handleNavigate('/dis_contact_group_member')}>

                                            <span className="list-icon">📖</span>

                                            <span className="list-title">{txt.myPhonebook}</span>

                                            <span className="list-count">{dashboardStats.contactGroup}</span>

                                            <svg className="list-arrow" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">

                                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />

                                            </svg>

                                        </div>

                                    </div>

                                </div>



                                {/* Only My Surname Group - No Volunteer Surname Group */}

                                <div className="col-12 col-md-6 col-lg-4 fade-in-up mt-2 mb-2" style={{ animationDelay: '0.6s' }}>

                                    <div className="single-card">

                                        <div className="single-row" onClick={() => handleNavigate('/dis_surname_group')}>

                                            <span className="list-icon">👪</span>

                                            <span className="list-title">{txt.surnameGroup}</span>

                                            <span className="list-count">{dashboardStats.surnameGroup}</span>

                                            <svg className="list-arrow" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">

                                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />

                                            </svg>

                                        </div>

                                    </div>

                                </div>



                                {/* Only My Group - No Volunteer Group */}

                                <div className="col-12 col-md-6 col-lg-4 fade-in-up mt-2 mb-2" style={{ animationDelay: '0.65s' }}>

                                    <div className="single-card">

                                        <div className="single-row" onClick={() => handleNavigate('/dis_my_group_member')}>

                                            <span className="list-icon">👥</span>

                                            <span className="list-title">{txt.myGroup}</span>

                                            <span className="list-count">{dashboardStats.myMember}</span>

                                            <svg className="list-arrow" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">

                                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />

                                            </svg>

                                        </div>

                                    </div>

                                </div>



                                {/* My Slip Send - New Card Added */}

                                <div className="col-12 col-md-6 col-lg-4 fade-in-up mt-2 mb-2" style={{ animationDelay: '0.7s' }}>

                                    <div className="single-card">

                                        <div className="single-row" onClick={() => handleNavigate('/dis_my_slip_sending_voter')}>

                                            <span className="list-icon">📨</span>

                                            <span className="list-title">{txt.mySlipSend}</span>

                                            <span className="list-count">{dashboardStats.slipSend}</span>

                                            <svg className="list-arrow" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">

                                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />

                                            </svg>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>





                        {/* Social Media Section with Animation - Mobile Responsive */}

                        <div className="section-card bg-gray border-0 p-0 fade-in-up" style={{ background: 'linear-gradient(120deg, #1e3a8a 0%, #3b82f6 100%)', animationDelay: '1.0s' }}>

                            <div className="p-3 d-flex align-items-center border-bottom" style={{ borderColor: 'rgba(255,255,255,0.2)' }}>

                                <div className="section-icon-bg bg-white me-2" style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>

                                    <span className="emoji-icon">📱</span>

                                </div>

                                <h5 className="mb-0 font-weight-bold" style={{ color: '#ffffff' }}>{txt.socialMedia}</h5>

                            </div>

                            <div className='row g-4 p-3 m-0 social-row'>

                                <ModernReportCard title={txt.socialUpdate} subtitle={txt.socialUpdate} icon={<HeadsetReportIcon />} color="#ec4899" delay="1.15s" onClick={() => { handleNavigate('/display_posts') }} />

                                {/* Help Video Card */}

                                <div className="col-12 col-md-6 fade-in-up mt-2 mb-2" style={{ animationDelay: '1.3s' }}>

                                    <div className="user-management-card" onClick={() => handleNavigate('/video_help')}>

                                        <div className="um-icon-wrapper" style={{ backgroundColor: '#10b981', color: 'white' }}>

                                            <svg width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">

                                                <path strokeLinecap="round" strokeLinejoin="round" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />

                                            </svg>

                                        </div>

                                        <div className="um-text-wrapper">

                                            <h5 className="um-title">{txt.helpVideo}</h5>

                                            <p className="um-subtitle">{txt.helpVideoSub}</p>

                                        </div>

                                        <div className="um-arrow">

                                            <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">

                                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />

                                            </svg>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </>

                )}



                {isShaktiKendra && (

                    <>

                        {/* Cadres Section with Distinct Background */}

                        <div className="section-card mb-4 p-0 fade-in-up" style={{ backgroundColor: '#ffffff', animationDelay: '0.2s' }}>

                            <div className="p-3 d-flex align-items-center border-bottom" style={{ borderColor: '#e2e8f0' }}>

                                <div className="section-icon-bg bg-white mr-2" style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>

                                    <span className="emoji-icon">👥</span>

                                </div>

                                <h5 className="mb-0 font-weight-bold" style={{ color: '#1e40af' }}>{txt.cadres}</h5>

                            </div>

                            <div className="row g-4 p-3 m-0" style={{ marginTop: '0px', paddingTop: '16px' }}>

                                <DashboardCard title={txt.boothPramukh} icon={<ThreePeopleIcon color="currentColor" />} color="#2563eb" delay="0.25s" onClick={() => handleNavigate('/booth_of_shakti_kendra')} />

                                <DashboardCard title={txt.matdar} icon={<ThreePeopleIcon color="currentColor" />} color="#f97316" delay="0.3s" onClick={() => handleNavigate('/shakti_kendra_voter')} />

                                <DashboardCard title={txt.karyakartaBP} icon={<MultiPeopleIcon />} color="#ec4899" delay="0.35s" onClick={() => handleNavigate('/display_karyakarta')} />

                            </div>

                        </div>



                        {/* Voter List Banner Animation - White Background */}

                        <div className="row mb-4 fade-in-up" style={{ animationDelay: '0.45s' }}>

                            <div className="col-12">

                                <div className="section-card voter-search-card" onClick={() => handleNavigate('/voter_list')} style={{ background: '#ffffff', padding: '16px 20px' }}>

                                    <div className="voter-icon-circle" style={{ background: '#f1f5f9' }}>

                                        <svg width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>

                                    </div>

                                    <div className="voter-text">

                                        <h3>{txt.voterList}</h3>



                                    </div>

                                    <div className="voter-count-display">

                                        <span className="voter-count-label">{txt.totalVoters}</span>

                                        <span className="voter-count-number">{total_voters?.toLocaleString()}</span>

                                    </div>

                                    <div className="arrow-icon">

                                        <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" /></svg>

                                    </div>

                                </div>

                            </div>

                        </div>



                        {/* Confirm Voters Section Wrapped with Animation - Only My Phonebook, My Group, My Surname Group, My Slip Send for Shakti Kendra */}

                        <div className="section-card mb-4 p-0 fade-in-up " style={{ backgroundColor: '#ffffff', animationDelay: '0.5s' }}>

                            <div className="p-3 d-flex align-items-center border-bottom" style={{ borderColor: '#e2e8f0' }}>

                                <div className="section-icon-bg bg-white me-2" style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>

                                    <span className="emoji-icon">✔️</span>

                                </div>

                                <h5 className="mb-0 font-weight-bold me-2" style={{ color: '#0f172a' }}>{txt.communication}</h5>

                                <div className="d-flex align-items-center ml-auto">



                                    <div className="arrow-right text-muted"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#64748b" strokeWidth="2"><path d="M9 5l7 7-7 7" /></svg></div>

                                </div>

                            </div>

                            <div className="row g-4 p-3 m-0" style={{ marginTop: '0px', paddingTop: '16px' }}>

                                {/* Only My Phonebook - No Volunteer Phonebook */}

                                <div className="col-12 col-md-6 col-lg-4 fade-in-up mt-2 mb-2" style={{ animationDelay: '0.55s' }}>

                                    <div className="single-card">

                                        <div className="single-row" onClick={() => handleNavigate('/dis_contact_group_member')}>

                                            <span className="list-icon">📖</span>

                                            <span className="list-title">{txt.myPhonebook}</span>

                                            <span className="list-count">{dashboardStats.contactGroup}</span>

                                            <svg className="list-arrow" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">

                                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />

                                            </svg>

                                        </div>

                                    </div>

                                </div>



                                {/* Only My Surname Group - No Volunteer Surname Group */}

                                <div className="col-12 col-md-6 col-lg-4 fade-in-up mt-2 mb-2" style={{ animationDelay: '0.6s' }}>

                                    <div className="single-card">

                                        <div className="single-row" onClick={() => handleNavigate('/dis_surname_group')}>

                                            <span className="list-icon">👪</span>

                                            <span className="list-title">{txt.surnameGroup}</span>

                                            <span className="list-count">{dashboardStats.surnameGroup}</span>

                                            <svg className="list-arrow" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">

                                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />

                                            </svg>

                                        </div>

                                    </div>

                                </div>



                                {/* Only My Group - No Volunteer Group */}

                                <div className="col-12 col-md-6 col-lg-4 fade-in-up mt-2 mb-2" style={{ animationDelay: '0.65s' }}>

                                    <div className="single-card">

                                        <div className="single-row" onClick={() => handleNavigate('/dis_my_group_member')}>

                                            <span className="list-icon">👥</span>

                                            <span className="list-title">{txt.myGroup}</span>

                                            <span className="list-count">{dashboardStats.myMember}</span>

                                            <svg className="list-arrow" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">

                                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />

                                            </svg>

                                        </div>

                                    </div>

                                </div>



                                {/* My Slip Send - New Card Added */}

                                <div className="col-12 col-md-6 col-lg-4 fade-in-up mt-2 mb-2" style={{ animationDelay: '0.7s' }}>

                                    <div className="single-card">

                                        <div className="single-row" onClick={() => handleNavigate('/dis_my_slip_sending_voter')}>

                                            <span className="list-icon">📨</span>

                                            <span className="list-title">{txt.mySlipSend}</span>

                                            <span className="list-count">{dashboardStats.slipSend}</span>

                                            <svg className="list-arrow" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">

                                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />

                                            </svg>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>



                        {/* Beneficiary & Live Voting Animation */}

                        <div className="row g-4 mb-5 fade-in-up" style={{ animationDelay: '0.85s' }}>

                            <HorizontalFeatureCard title={txt.beneficiary} subtitle={txt.benefeciarySub} icon={<GiftIcon />} iconBgColor="#f43f5e" subtitleColor="#e11d48" delay="0.85s" onClick={() => handleNavigate('/beneficiary')} />

                            <HorizontalFeatureCard title={txt.liveVoting} subtitle={txt.liveVotingSub} icon={<ChartBarIcon />} iconBgColor="#10b981" subtitleColor="#059669" delay="0.9s" onClick={() => handleNavigate('/live_Voting_cader')} />

                        </div>



                        {/* Reports Section Wrapped with Animation */}

                        <div className="section-card bg-gray mb-4 p-0 fade-in-up" style={{ backgroundColor: '#ffffff', animationDelay: '0.8s' }}>

                            <div className="p-3 d-flex align-items-center border-bottom" style={{ borderColor: '#e2e8f0' }}>

                                <div className="section-icon-bg bg-white mr-2" style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>

                                    <span className="emoji-icon">📊</span>

                                </div>

                                <h5 className="mb-0 font-weight-bold" style={{ color: '#0f172a' }}>{txt.reports}</h5>

                            </div>

                            <div className="row g-4 p-3 m-0">

                                <ModernReportCard title={txt.slipSendingReport} subtitle={txt.slipSendingReportSub} icon={<ReportIcon />} color="#22c55e" delay="0.85s" onClick={() => { handleNavigate('/shakti_kendra_slip_send_dash') }} />

                                <ModernReportCard title={txt.survey} subtitle={txt.cadreWiseSurveySub} icon={<SurveyIcon />} color="#f97316" delay="0.9s" onClick={() => { handleNavigate('/shakti_kendra_survey_dash') }} />

                            </div>

                        </div>



                        {/* Social Media Section with Animation - Mobile Responsive */}

                        <div className="section-card bg-gray border-0 p-0 fade-in-up" style={{ background: 'linear-gradient(120deg, #1e3a8a 0%, #3b82f6 100%)', animationDelay: '1.0s' }}>

                            <div className="p-3 d-flex align-items-center border-bottom" style={{ borderColor: 'rgba(255,255,255,0.2)' }}>

                                <div className="section-icon-bg bg-white me-2" style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>

                                    <span className="emoji-icon">📱</span>

                                </div>

                                <h5 className="mb-0 font-weight-bold" style={{ color: '#ffffff' }}>{txt.socialMedia}</h5>

                            </div>

                            <div className='row g-4 p-3 m-0 social-row'>





                                <ModernReportCard title={txt.socialUpdate} subtitle={txt.socialUpdate} icon={<HeadsetReportIcon />} color="#ec4899" delay="1.15s" onClick={() => { handleNavigate('/display_posts') }} />

                                {/* Help Video Card */}

                                <div className="col-12 col-md-6 fade-in-up mt-2 mb-2" style={{ animationDelay: '1.3s' }}>

                                    <div className="user-management-card" onClick={() => handleNavigate('/video_help')}>


                                        <div className="um-icon-wrapper" style={{ backgroundColor: '#10b981', color: 'white' }}>

                                            <svg width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">

                                                <path strokeLinecap="round" strokeLinejoin="round" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />

                                            </svg>

                                        </div>

                                        <div className="um-text-wrapper">

                                            <h5 className="um-title">{txt.helpVideo}</h5>

                                            <p className="um-subtitle">{txt.helpVideoSub}</p>

                                        </div>

                                        <div className="um-arrow">

                                            <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">

                                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />

                                            </svg>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </>

                )}


                {isCallCenter && (
                    <>
                        {/* Call Center Stats Cards */}
                        <div className="stats-container-callcenter mb-4 slide-up-element" style={{ animationDelay: '0.15s' }}>
                            <div className="stat-card-callcenter total-booth-card">
                                <div className="stat-icon-callcenter">🏪</div>
                                <div className="stat-info-callcenter">
                                    <span className="stat-label-callcenter">Total Booth</span>
                                    <span className="stat-value-callcenter">2</span>
                                </div>
                            </div>
                            <div className="stat-card-callcenter total-voter-card">
                                <div className="stat-icon-callcenter">👥</div>
                                <div className="stat-info-callcenter">
                                    <span className="stat-label-callcenter">Total Voter</span>
                                    <span className="stat-value-callcenter">1264</span>
                                </div>
                            </div>
                            <div className="stat-card-callcenter total-survey-card">
                                <div className="stat-icon-callcenter">📊</div>
                                <div className="stat-info-callcenter">
                                    <span className="stat-label-callcenter">Total Survey</span>
                                    <span className="stat-value-callcenter">369</span>
                                </div>
                            </div>
                            <div className="stat-card-callcenter today-survey-card">
                                <div className="stat-icon-callcenter">📅</div>
                                <div className="stat-info-callcenter">
                                    <span className="stat-label-callcenter">Today Survey</span>
                                    <span className="stat-value-callcenter">0</span>
                                </div>
                            </div>
                        </div>
                        {/* My Booth Section - Display all booths from boothNo */}
                        {boothNo && (
                            <div className="my-booth-section mb-4 slide-up-element" style={{ animationDelay: '0.12s' }}>
                                <div className="section-card p-0 fade-in-up" style={{ backgroundColor: '#ffffff' }}>
                                    <div className="p-3 d-flex align-items-center border-bottom" style={{ borderColor: '#e2e8f0' }}>
                                        <div className="section-icon-bg bg-white me-2" style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
                                            <span className="emoji-icon">🏪</span>
                                        </div>
                                        <h5 className="mb-0 font-weight-bold" style={{ color: '#1e40af' }}>My Booth</h5>
                                    </div>
                                    <div className="p-3">
                                        <div className="booth-cards-container">
                                            {boothNo.split(',').filter(booth => booth.trim()).map((booth, index) => (
                                                <div key={index} className="booth-square-card" onClick={() => navigate('/dis_booth_wise_voter_list_for_call_center', { state: { boothNo: booth.trim() } })}>
                                                    <div className="booth-card-icon">
                                                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                                                            <path d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z" />
                                                            <path d="M12 2v5" />
                                                            <path d="M9 7h6" />
                                                        </svg>
                                                    </div>
                                                    <div className="booth-card-number">{booth.trim()}</div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </>
                )}




                {isBoothPramukh || isSahBoothPramukh ? (

                    <>

                        {/* Cadres Section with Distinct Background */}

                        <div className="section-card mb-4 p-0 fade-in-up" style={{ backgroundColor: '#ffffff', animationDelay: '0.2s' }}>

                            <div className="p-3 d-flex align-items-center border-bottom" style={{ borderColor: '#e2e8f0' }}>

                                <div className="section-icon-bg bg-white mr-2" style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>

                                    <span className="emoji-icon">👥</span>

                                </div>

                                <h5 className="mb-0 font-weight-bold" style={{ color: '#1e40af' }}>{txt.cadres}</h5>

                            </div>

                            <div className="row g-4 p-3 m-0" style={{ marginTop: '0px', paddingTop: '16px' }}>

                                <DashboardCard title={txt.sangathan} icon={<ThreePeopleIcon color="currentColor" />} color="#2563eb" delay="0.25s" onClick={() => handleNavigate('/orgaization')} />

                                <DashboardCard title={txt.matdar} icon={<ThreePeopleIcon color="currentColor" />} color="#f97316" delay="0.3s" onClick={() => handleNavigate('/voter')} />

                                <DashboardCard title={txt.karyakartaBP} icon={<MultiPeopleIcon />} color="#ec4899" delay="0.35s" onClick={() => handleNavigate('/display_karyakarta')} />

                            </div>

                        </div>



                        {/* Voter List Banner Animation - White Background */}

                        <div className="row mb-4 fade-in-up" style={{ animationDelay: '0.45s' }}>

                            <div className="col-12">

                                <div className="section-card voter-search-card" onClick={() => handleNavigate('/voter_list')} style={{ background: '#ffffff', padding: '16px 20px' }}>

                                    <div className="voter-icon-circle" style={{ background: '#f1f5f9' }}>

                                        <svg width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>

                                    </div>

                                    <div className="voter-text">

                                        <h3>{txt.voterList}</h3>



                                    </div>

                                    <div className="voter-count-display">

                                        <span className="voter-count-label">{txt.totalVoters}</span>

                                        <span className="voter-count-number">{total_voters?.toLocaleString()}</span>

                                    </div>

                                    <div className="arrow-icon">

                                        <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" /></svg>

                                    </div>

                                </div>

                            </div>

                        </div>

                        {/* Confirm Voters Section Wrapped with Animation - Only My Phonebook, My Group, My Surname Group for Shakti Kendra */}

                        <div className="section-card mb-4 p-0 fade-in-up " style={{ backgroundColor: '#ffffff', animationDelay: '0.5s' }}>

                            <div className="p-3 d-flex align-items-center border-bottom" style={{ borderColor: '#e2e8f0' }}>

                                <div className="section-icon-bg bg-white me-2" style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>

                                    <span className="emoji-icon">✔️</span>

                                </div>

                                <h5 className="mb-0 font-weight-bold me-2" style={{ color: '#0f172a' }}>{txt.communication}</h5>

                                <div className="d-flex align-items-center ml-auto">



                                    <div className="arrow-right text-muted"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#64748b" strokeWidth="2"><path d="M9 5l7 7-7 7" /></svg></div>

                                </div>

                            </div>

                            <div className="row g-4 p-3 m-0" style={{ marginTop: '0px', paddingTop: '16px' }}>

                                {/* Only My Phonebook - No Volunteer Phonebook */}

                                <div className="col-12 col-md-6 col-lg-4 fade-in-up mt-2 mb-2" style={{ animationDelay: '0.55s' }}>

                                    <div className="single-card">

                                        <div className="single-row" onClick={() => handleNavigate('/dis_contact_group_member')}>

                                            <span className="list-icon">📖</span>

                                            <span className="list-title">{txt.myPhonebook}</span>

                                            <span className="list-count">{dashboardStats.contactGroup}</span>

                                            <svg className="list-arrow" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">

                                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />

                                            </svg>

                                        </div>

                                    </div>

                                </div>



                                {/* Only My Surname Group - No Volunteer Surname Group */}

                                <div className="col-12 col-md-6 col-lg-4 fade-in-up mt-2 mb-2" style={{ animationDelay: '0.6s' }}>

                                    <div className="single-card">

                                        <div className="single-row" onClick={() => handleNavigate('/dis_surname_group')}>

                                            <span className="list-icon">👪</span>

                                            <span className="list-title">{txt.surnameGroup}</span>

                                            <span className="list-count">{dashboardStats.surnameGroup}</span>

                                            <svg className="list-arrow" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">

                                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />

                                            </svg>

                                        </div>

                                    </div>

                                </div>



                                {/* Only My Group - No Volunteer Group */}

                                <div className="col-12 col-md-6 col-lg-4 fade-in-up mt-2 mb-2" style={{ animationDelay: '0.65s' }}>

                                    <div className="single-card">

                                        <div className="single-row" onClick={() => handleNavigate('/dis_my_group_member')}>

                                            <span className="list-icon">👥</span>

                                            <span className="list-title">{txt.myGroup}</span>

                                            <span className="list-count">{dashboardStats.myMember}</span>

                                            <svg className="list-arrow" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">

                                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />

                                            </svg>

                                        </div>

                                    </div>

                                </div>



                                {/* My Slip Send - New Card Added */}

                                <div className="col-12 col-md-6 col-lg-4 fade-in-up mt-2 mb-2" style={{ animationDelay: '0.7s' }}>

                                    <div className="single-card">

                                        <div className="single-row" onClick={() => handleNavigate('/dis_my_slip_sending_voter')}>

                                            <span className="list-icon">📨</span>

                                            <span className="list-title">{txt.mySlipSend}</span>

                                            <span className="list-count">{dashboardStats.slipSend}</span>

                                            <svg className="list-arrow" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">

                                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />

                                            </svg>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>



                        {/* Beneficiary & Live Voting Animation */}

                        <div className="row g-4 mb-5 fade-in-up" style={{ animationDelay: '0.85s' }}>

                            <HorizontalFeatureCard title={txt.beneficiary} subtitle={txt.benefeciarySub} icon={<GiftIcon />} iconBgColor="#f43f5e" subtitleColor="#e11d48" delay="0.85s" onClick={() => handleNavigate('/beneficiary')} />

                            <HorizontalFeatureCard title={txt.liveVoting} subtitle={txt.liveVotingSub} icon={<ChartBarIcon />} iconBgColor="#10b981" subtitleColor="#059669" delay="0.9s" onClick={() => handleNavigate('/live_Voting_cader')} />

                        </div>



                        {/* Reports Section Wrapped with Animation */}

                        <div className="section-card bg-gray mb-4 p-0 fade-in-up" style={{ backgroundColor: '#ffffff', animationDelay: '0.8s' }}>

                            <div className="p-3 d-flex align-items-center border-bottom" style={{ borderColor: '#e2e8f0' }}>

                                <div className="section-icon-bg bg-white mr-2" style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>

                                    <span className="emoji-icon">📊</span>

                                </div>

                                <h5 className="mb-0 font-weight-bold" style={{ color: '#0f172a' }}>{txt.reports}</h5>

                            </div>

                            <div className="row g-4 p-3 m-0">

                                <ModernReportCard title={txt.slipSendingReport} subtitle={txt.slipSendingReportSub} icon={<ReportIcon />} color="#22c55e" delay="0.85s" onClick={() => { handleNavigate('/slipsenddash') }} />

                                <ModernReportCard title={txt.survey} subtitle={txt.cadreWiseSurveySub} icon={<SurveyIcon />} color="#f97316" delay="0.9s" onClick={() => { handleNavigate('/booth_pramukha_survey_dash') }} />

                            </div>

                        </div>



                        {/* Social Media Section with Animation - Mobile Responsive */}

                        <div className="section-card bg-gray border-0 p-0 fade-in-up" style={{ background: 'linear-gradient(120deg, #1e3a8a 0%, #3b82f6 100%)', animationDelay: '1.0s' }}>

                            <div className="p-3 d-flex align-items-center border-bottom" style={{ borderColor: 'rgba(255,255,255,0.2)' }}>

                                <div className="section-icon-bg bg-white me-2" style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>

                                    <span className="emoji-icon">📱</span>

                                </div>

                                <h5 className="mb-0 font-weight-bold" style={{ color: '#ffffff' }}>{txt.socialMedia}</h5>

                            </div>

                            <div className='row g-4 p-3 m-0 social-row'>





                                <ModernReportCard title={txt.socialUpdate} subtitle={txt.socialUpdate} icon={<HeadsetReportIcon />} color="#ec4899" delay="1.15s" onClick={() => { handleNavigate('/display_posts') }} />

                                {/* Help Video Card */}

                                <div className="col-12 col-md-6 fade-in-up mt-2 mb-2" style={{ animationDelay: '1.3s' }}>

                                    <div className="user-management-card" onClick={() => handleNavigate('/video_help')}>

                                        <div className="um-icon-wrapper" style={{ backgroundColor: '#10b981', color: 'white' }}>

                                            <svg width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">

                                                <path strokeLinecap="round" strokeLinejoin="round" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />

                                            </svg>

                                        </div>

                                        <div className="um-text-wrapper">

                                            <h5 className="um-title">{txt.helpVideo}</h5>

                                            <p className="um-subtitle">{txt.helpVideoSub}</p>

                                        </div>

                                        <div className="um-arrow">

                                            <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">

                                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />

                                            </svg>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>





                    </>

                ) : (

                    <>

                        {/* --- REGULAR DASHBOARD VIEW (Non-BP) --- */}

                        {(isAdmin || isSubAdmin) && (

                            <>

                                {/* Cadres Section with Distinct Background */}

                                <div className="section-card mb-5 p-0 fade-in-up" style={{ backgroundColor: 'white', animationDelay: '0.2s' }}>

                                    <div className="p-3 d-flex align-items-center border-bottom" style={{ borderColor: '#334155' }}>

                                        <div className="section-icon-bg bg-white me-2" style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>

                                            <span className="emoji-icon">👥</span>

                                        </div>

                                        <h5 className="mb-0 font-weight-bold" style={{ color: '#1e40af' }}>{txt.reach}</h5>

                                    </div>

                                    <div className="row g-4 p-3 m-0" style={{ marginTop: '0px', paddingTop: '16px' }}>

                                        {isAdmin && (

                                            <>

                                                <DashboardCard title={txt.admin} icon={<UserGearIcon />} color="#0ea5e9" delay="0.25s" onClick={() => handleNavigate('/admin')} />

                                                <DashboardCard title={txt.subAdmin} icon={<UserGroupIcon />} color="#f59e0b" delay="0.3s" onClick={() => handleNavigate('/sub_admin')} />

                                                <DashboardCard title={txt.partyCader} icon={<MultiPeopleIcon />} color="#10b981" delay="0.35s" onClick={() => handleNavigate('/party_cader')} />

                                                <DashboardCard title={txt.personalCader} icon={<ThreePeopleIcon color="currentColor" />} color="#ec4899" delay="0.4s" onClick={() => handleNavigate('/personal_cader')} />

                                                <DashboardCard title={txt.callCenter} icon={<HeadsetIcon />} color="#8b5cf6" delay="0.45s" onClick={() => handleNavigate('/dis_call_center_user')} />

                                                <DashboardCard title={txt.bulkPrachar} icon={<ReportIcon />} color="#6366f1" delay="0.5s" onClick={() => handleNavigate('/bulk_prachar')} />

                                            </>

                                        )}

                                        {(!isAdmin && isSubAdmin) && (

                                            <>

                                                <DashboardCard title={txt.shaktiKendra} subtitle="Pramukh" icon={<BuildingIcon />} color="#10b981" delay="0.25s" onClick={() => handleNavigate('/dis_saktikendra')} />

                                                <DashboardCard title={txt.boothPramukh} icon={<BoothIcon />} color="#6366f1" delay="0.3s" onClick={() => handleNavigate('/booth_pramukh')} />

                                                <DashboardCard title={txt.volunteer} icon={<VolunteerIcon />} color="#ec4899" delay="0.35s" onClick={() => handleNavigate('/display_karyakarta')} />

                                            </>

                                        )}

                                    </div>

                                </div>



                                {/* Voter List Banner Animation - White Background */}

                                <div className="row mb-5 fade-in-up" style={{ animationDelay: '0.45s' }}>

                                    <div className="col-12">

                                        <div className="section-card voter-search-card" onClick={() => handleNavigate('/voter_list')} style={{ background: '#ffffff', padding: '16px 20px' }}>

                                            <div className="voter-icon-circle" style={{ background: '#f1f5f9' }}>

                                                <svg width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>

                                            </div>

                                            <div className="voter-text">

                                                <h3>{txt.voterList}</h3>



                                            </div>

                                            <div className="voter-count-display">

                                                <span className="voter-count-label">{txt.totalVoters}</span>

                                                <span className="voter-count-number">{total_voters?.toLocaleString()}</span>

                                            </div>

                                            <div className="arrow-icon">

                                                <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" /></svg>

                                            </div>

                                        </div>

                                    </div>

                                </div>



                                {/* Confirm Voters Section Wrapped with Animation */}

                                <div className="section-card mb-5 p-0 fade-in-up" style={{ backgroundColor: '#ffffff', animationDelay: '0.5s' }}>

                                    <div className="p-3 d-flex align-items-center border-bottom" style={{ borderColor: '#e2e8f0' }}>

                                        <div className="section-icon-bg bg-white me-2" style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>

                                            <span className="emoji-icon">✔️</span>

                                        </div>

                                        <h5 className="mb-0 font-weight-bold me-2" style={{ color: '#0f172a' }}>{txt.communication}</h5>

                                        <div className="d-flex align-items-center ml-auto">

                                            <div className="badge-count me-2" style={{ backgroundColor: '#ca8a04', color: 'white' }}>{dashboardStats.totalConfirmVoter.toLocaleString()}</div>

                                            <div className="arrow-right text-muted"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#64748b" strokeWidth="2"><path d="M9 5l7 7-7 7" /></svg></div>

                                        </div>

                                    </div>

                                    <div className="row g-4 p-3 m-0" style={{ marginTop: '0px', paddingTop: '16px' }}>

                                        <CombinedDashboardCard

                                            title1={txt.myPhonebook}

                                            count1={dashboardStats.contactGroup}

                                            icon1="📖"

                                            onClick1={() => handleNavigate('/dis_contact_group_member')}

                                            title2={txt.volunteerPhonebook}

                                            count2={dashboardStats.contactGroupUser}

                                            icon2="📒"

                                            onClick2={() => handleNavigate('/dis_all_contact_match_admin')}

                                            delay="0.55s"

                                        />

                                        <CombinedDashboardCard

                                            title1={txt.surnameGroup}

                                            count1={dashboardStats.surnameGroup}

                                            icon1="👪"

                                            onClick1={() => handleNavigate('/dis_surname_group')}

                                            title2={txt.volSurnameGroup}

                                            count2={dashboardStats.surnameGroupUser}

                                            icon2="👨‍👩‍👧‍👦"

                                            onClick2={() => handleNavigate('/display_surname_match_admin')}

                                            delay="0.6s"

                                        />

                                        <CombinedDashboardCard

                                            title1={txt.myGroup}

                                            count1={dashboardStats.myMember}

                                            icon1="👥"

                                            onClick1={() => handleNavigate('/dis_my_group_member')}

                                            title2={txt.volunteerGroup}

                                            count2={dashboardStats.memberGroupUser}

                                            icon2="🧑‍🤝‍🧑"

                                            onClick2={() => handleNavigate('/dis_user_list_by_create_group')}

                                            delay="0.65s"

                                        />

                                    </div>

                                </div>



                                {/* Beneficiary & Live Voting Animation */}

                                <div className="row g-4 mb-4 fade-in-up" style={{ animationDelay: '0.85s' }}>

                                    <HorizontalFeatureCard title={txt.beneficiary} subtitle={txt.benefeciarySub} icon={<GiftIcon />} iconBgColor="#f43f5e" subtitleColor="#e11d48" delay="0.85s" onClick={() => handleNavigate('/beneficiary')} />

                                    <HorizontalFeatureCard title={txt.liveVoting} subtitle={txt.liveVotingSub} icon={<ChartBarIcon />} iconBgColor="#10b981" subtitleColor="#059669" delay="0.9s" onClick={() => handleNavigate('/live_voting')} />

                                </div>


                                {/* --- BULK META SLIP SECTION --- */}
                                {(isAdmin || isSubAdmin) && aacharSahita === 0 && (
                                    <div className="section-card border-0 p-0 fade-in-up mb-4" style={{
                                        backgroundColor: '#097969', /* Your specified green color */
                                        animationDelay: '1.35s',
                                        marginTop: '30px',
                                        border: '1px solid #065a4f' /* Darker version for border */
                                    }}>
                                        <div className="p-3 d-flex align-items-center border-bottom" style={{
                                            borderColor: '#065a4f',
                                            backgroundColor: '#087a68' /* Slightly lighter header */
                                        }}>
                                            <div className="section-icon-bg bg-white me-2" style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
                                                <span className="emoji-icon">📋</span>
                                            </div>
                                            <h5 className="mb-0 font-weight-bold" style={{ color: '#ffffff' /* White text for better contrast */ }}>
                                                {txt.bulkMetaSlip}
                                            </h5>
                                        </div>
                                        <div className="row g-4 p-3 m-0" style={{ marginTop: '0px', paddingTop: '16px' }}>
                                            {/* My Wallet Card */}
                                            <div className="col-12 col-md-6 fade-in-up mt-2 mb-2" style={{ animationDelay: '1.4s' }}>
                                                <div className="user-management-card" onClick={() => handleNavigate('/dis_wtsp_wallet_dashboard')} style={{ backgroundColor: 'white' }}>
                                                    <div className="um-icon-wrapper" style={{ backgroundColor: '#8b5cf6', color: 'white' }}>
                                                        <svg width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                                                        </svg>
                                                    </div>
                                                    <div className="um-text-wrapper">
                                                        <h5 className="um-title">{txt.myWallet}</h5>
                                                        <p className="um-subtitle">Manage your wallet and credits</p>
                                                    </div>
                                                    <div className="um-arrow">
                                                        <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                                                        </svg>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Bulk Slip Card */}
                                            {metaWtsp === 1 && (
                                                <div className="col-12 col-md-6 fade-in-up mt-2 mb-2" style={{ animationDelay: '1.45s' }}>
                                                    <div className="user-management-card" onClick={() => handleNavigate('/bulk_meta_slip')} style={{ backgroundColor: 'white' }}>
                                                        <div className="um-icon-wrapper" style={{ backgroundColor: '#f59e0b', color: 'white' }}>
                                                            <svg width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" />
                                                            </svg>
                                                        </div>
                                                        <div className="um-text-wrapper">
                                                            <h5 className="um-title">{txt.bulkSlip}</h5>
                                                            <p className="um-subtitle">Send bulk slips to voters</p>
                                                        </div>
                                                        <div className="um-arrow">
                                                            <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                                                            </svg>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}

                                {/* Reports Section Wrapped with Animation - Mobile Responsive */}

                                <div className="section-card bg-gray mb-5 p-0 fade-in-up" style={{ backgroundColor: '#ffffff', animationDelay: '0.8s' }}>

                                    <div className="p-3 d-flex align-items-center border-bottom" style={{ borderColor: '#e2e8f0' }}>

                                        <div className="section-icon-bg bg-white me-2" style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>

                                            <span className="emoji-icon">📊</span>

                                        </div>

                                        <h5 className="mb-0 font-weight-bold" style={{ color: '#0f172a' }}>{txt.reports}</h5>

                                    </div>

                                    <div className="row g-4 p-3 m-0 report-row">

                                        <ModernReportCard title={txt.slipSendingReport} subtitle={txt.slipSendingReportSub} icon={<ReportIcon />} color="#22c55e" delay="0.85s" onClick={() => { handleNavigate('/get_total_slip_distribution_count') }} />

                                        <ModernReportCard title={txt.cadreWiseSurvey} subtitle={txt.cadreWiseSurveySub} icon={<SurveyIcon />} color="#f97316" delay="0.9s" onClick={() => { handleNavigate('/dis_survey_dash_for_admin') }} />

                                        {/* NEW: My Slip Send Card */}
                                        <ModernReportCard title={txt.mySlipSend} subtitle={txt.mySlipSendSub} icon={<ReportIcon />} color="#8b5cf6" delay="0.95s" onClick={() => { handleNavigate('/dis_my_slip_sending_voter') }} />

                                        {/* <ModernReportCard title={txt.callCenterSurvey} subtitle={txt.callCenterSurveySub} icon={<HeadsetReportIcon />} color="#3b82f6" delay="0.95s" onClick={() => { handleNavigate('/dis_admin_call_center_survey_dashboard') }} /> */}

                                    </div>

                                </div>



                                {/* Social Media Section with Animation - Mobile Responsive */}

                                <div className="section-card bg-gray border-0 p-0 fade-in-up" style={{ background: 'linear-gradient(120deg, #1e3a8a 0%, #3b82f6 100%)', animationDelay: '1.0s' }}>

                                    <div className="p-3 d-flex align-items-center border-bottom" style={{ borderColor: 'rgba(255,255,255,0.2)' }}>

                                        <div className="section-icon-bg bg-white me-2" style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>

                                            <span className="emoji-icon">📱</span>

                                        </div>

                                        <h5 className="mb-0 font-weight-bold" style={{ color: '#ffffff' }}>{txt.socialMedia}</h5>

                                    </div>

                                    <div className='row g-4 p-3 m-0 social-row'>
                                        {prachar && (
                                            <ModernReportCard title={txt.pracharMaster} subtitle={txt.pracharMasterSub} icon={<SurveyIcon />} color="#8b5cf6" delay="1.05s" onClick={() => { handleNavigate('/prachar_master') }} />
                                        )}
                                        <ModernReportCard title={txt.starVolunteer} subtitle={txt.starVolunteerSub} icon={<HeadsetReportIcon />} color="#ec4899" delay="1.1s" onClick={() => { handleNavigate('/dis_star_karykarta') }} />

                                        <ModernReportCard title={txt.socialUpdate} subtitle={txt.socialUpdate} icon={<HeadsetReportIcon />} color="#ec4899" delay="1.15s" onClick={() => { handleNavigate('/display_posts') }} />



                                    </div>

                                </div>

                            </>

                        )}



                        {/* --- NEW USER MANAGEMENT SECTION (Visible for Admin & SubAdmin) - Mobile Responsive --- */}

                        {(isAdmin || isSubAdmin) && (

                            <div className="section-card border-0 p-0 fade-in-up" style={{ backgroundColor: '#ffffff', animationDelay: '1.2s', marginTop: '30px' }}>

                                <div className="p-3 d-flex align-items-center border-bottom" style={{ borderColor: '#e2e8f0' }}>

                                    <div className="section-icon-bg bg-white me-2" style={{ boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>

                                        <span className="emoji-icon">👥</span>

                                    </div>

                                    <h5 className="mb-0 font-weight-bold" style={{ color: '#0f172a' }}>{txt.userManagement}</h5>

                                </div>

                                <div className="row g-4 p-3 m-0 user-row" style={{ marginTop: '0px', paddingTop: '16px' }}>

                                    {/* All Users Card */}

                                    <div className="col-12 col-md-6 fade-in-up mt-2 mb-2" style={{ animationDelay: '1.25s' }}>

                                        <div className="user-management-card" onClick={() => handleNavigate('/dis_all_user')}>

                                            <div className="um-icon-wrapper" style={{ backgroundColor: '#3b82f6', color: 'white' }}>

                                                <svg width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">

                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />

                                                </svg>

                                            </div>

                                            <div className="um-text-wrapper">

                                                <h5 className="um-title">{txt.allUsers}</h5>

                                                <p className="um-subtitle">{txt.allUsersSub}</p>

                                            </div>

                                            <div className="um-arrow">

                                                <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">

                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />

                                                </svg>

                                            </div>

                                        </div>

                                    </div>



                                    {/* Help Video Card */}

                                    <div className="col-12 col-md-6 fade-in-up mt-2 mb-2" style={{ animationDelay: '1.3s' }}>

                                        <div className="user-management-card" onClick={() => handleNavigate('/video_help')}>

                                            <div className="um-icon-wrapper" style={{ backgroundColor: '#10b981', color: 'white' }}>

                                                <svg width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">

                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />

                                                </svg>
                                            </div>
                                            <div className="um-text-wrapper">
                                                <h5 className="um-title">{txt.helpVideo}</h5>
                                                <p className="um-subtitle">{txt.helpVideoSub}</p>
                                            </div>
                                            <div className="um-arrow">
                                                <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </>
                )}
            </div>
            <style jsx>{`
                /* Animation Keyframes */
                @keyframes fadeInUp {
                    from {
                        opacity: 0;
                        transform: translateY(30px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
                
                @keyframes slideUp {
                    from {
                        opacity: 0;
                        transform: translateY(20px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
                
                .fade-in-up {
                    opacity: 0;
                    animation: fadeInUp 0.4s cubic-bezier(0.2, 0.9, 0.4, 1.1) forwards;
                }
                
                .slide-up-element {
                    opacity: 0;
                    animation: slideUp 0.4s ease-out forwards;
                }
                
                .info-card { background: white; border-radius: 16px; padding: 20px 24px; border: 1px solid #334155 !important; transition: all 0.3s ease; }
                .info-card-content { display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 20px; }
                .info-item { display: flex; flex-direction: column; gap: 8px; }
                .info-label { font-size: 0.75rem; font-weight: 600; color: #64748b; text-transform: uppercase; letter-spacing: 0.5px; }
                .info-value-group { display: flex; align-items: baseline; gap: 8px; flex-wrap: wrap; }
                .info-number { font-size: 1.25rem; font-weight: 800; color: #ea580c; background: #fff7ed; padding: 4px 10px; border-radius: 8px; }
                .info-name { font-size: 1.1rem; font-weight: 700; color: #0B1120; }
                .info-number-large { font-size: 1.75rem; font-weight: 800; color:"#0B1120" padding: 4px 12px; border-radius: 10px; line-height: 1.2; }
                .info-divider { width: 1px; height: 50px; background: #e2e8f0; }

                .voter-count-display { display: flex; align-items: baseline; gap: 8px; background: linear-gradient(135deg, #d4af37 0%, #ffdf73 50%, #b8952a 100%); box-shadow: 0 4px 10px rgba(212, 175, 55, 0.3); padding: 8px 16px; border-radius: 40px; margin-left: auto; margin-right: 16px; }
                .voter-count-label { font-size: 0.8rem; font-weight: 700; color: #1e293b; }
                .voter-count-number { font-size: 1.3rem; font-weight: 900; color: #1e293b; }

                .badge-count { background-color: #ca8a04; color: white; padding: 4px 12px; border-radius: 20px; font-weight: bold; font-size: 13px; }
                
                /* Added Section Card Border CSS */
                .section-card { border-radius: 12px; overflow: hidden; border: 1px solid #334155 !important; box-shadow: none !important; }
                .section-icon-bg { width: 32px; height: 32px; border-radius: 8px; display: flex; align-items: center; justify-content: center; }
                
                .modern-report-card { background: #ffffff; border-radius: 16px; padding: 20px; display: flex; align-items: center; gap: 16px; border: 1px solid #334155 !important; cursor: pointer; transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1); height: 100%; box-shadow: 0 4px 12px rgba(0,0,0,0.03); }
                .modern-report-card:hover { transform: translateY(-4px); box-shadow: 0 12px 24px -8px rgba(0,0,0,0.1); border-color: #cbd5e1; }
                .mr-icon-box { width: 52px; height: 52px; border-radius: 14px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; box-shadow: inset 0 2px 4px rgba(255,255,255,0.5); }
                .mr-text-box { display: flex; flex-direction: column; gap: 4px; }
                .mr-title { margin: 0; font-size: 1.05rem; font-weight: 700; color: #1e293b; line-height: 1.2; }
                .mr-subtitle { margin: 0; font-size: 0.8rem; font-weight: 500; color: #64748b; line-height: 1.3; }

                .single-card { background: white; border-radius: 12px; border: 1px solid #334155 !important; overflow: hidden; display: flex; flex-direction: column; height: 100%; transition: transform 0.2s ease, box-shadow 0.2s ease; box-shadow: 0 1px 3px rgba(0,0,0,0.05); }
                .single-card:hover { transform: translateY(-2px); box-shadow: 0 4px 12px rgba(0,0,0,0.08); }
                .single-row { padding: 16px; display: flex; align-items: center; cursor: pointer; transition: background 0.2s; flex: 1; gap: 12px; }
                .single-row:hover { background-color: #f8fafc; }
                .list-icon { font-size: 1.4rem; display: flex; align-items: center; flex-shrink: 0; }
                .list-title { flex: 1; font-weight: 600; color: #334155; font-size: 1rem; }
                .list-count { font-size: 1rem; font-weight: 800; color: #ca8a04; background: #fef3c7; padding: 4px 12px; border-radius: 20px; min-width: 45px; text-align: center; display: inline-block; }
                .list-arrow { color: #cbd5e1; transition: color 0.2s; flex-shrink: 0; }
                .single-row:hover .list-arrow { color: #64748b; }
                .single-row:hover .list-count { background: #fde68a; transform: scale(1.05); }

                .combined-card { background: white; border-radius: 12px; border: 1px solid #334155 !important; overflow: hidden; display: flex; flex-direction: column; height: 100%; transition: transform 0.2s ease, box-shadow 0.2s ease; box-shadow: 0 1px 3px rgba(0,0,0,0.05); }
                .combined-card:hover { transform: translateY(-2px); box-shadow: 0 4px 12px rgba(0,0,0,0.08); }
                .combined-row { padding: 16px; display: flex; align-items: center; cursor: pointer; transition: background 0.2s; flex: 1; }
                .combined-row:hover { background-color: #f8fafc; }
                .combined-divider { height: 1px; background-color: #f1f5f9; width: 100%; }
                .list-icon { font-size: 1.4rem; margin-right: 14px; display: flex; align-items: center; }
                .list-title { flex-grow: 1; font-weight: 600; color: #334155; font-size: 1rem; }
                .list-arrow { color: #cbd5e1; transition: color 0.2s; }
                .combined-row:hover .list-arrow { color: #64748b; }

                .horizontal-feature-card { background: white; border-radius: 16px; border: 1px solid #334155 !important; padding: 20px; display: flex; align-items: center; gap: 20px; cursor: pointer; transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1); box-shadow: 0 4px 12px rgba(0,0,0,0.03); height: 100%; }
                .horizontal-feature-card:hover { transform: translateY(-4px); box-shadow: 0 12px 24px -8px rgba(0,0,0,0.08); border-color: #cbd5e1; }
                .hf-icon-wrapper { width: 60px; height: 60px; border-radius: 16px; display: flex; align-items: center; justify-content: center; color: white; flex-shrink: 0; box-shadow: 0 4px 10px rgba(0,0,0,0.15); }
                .hf-text-wrapper { display: flex; flex-direction: column; align-items: flex-start; }
                .hf-title { font-size: 1.15rem; font-weight: 700; color: #0f172a; margin: 0 0 6px 0; }
                .hf-subtitle { font-size: 0.85rem; font-weight: 600; padding-bottom: 2px; border-bottom: 2px solid; opacity: 0.85; }

                /* User Management Card Styles */
                .user-management-card {
                    background: white;
                    border-radius: 16px;
                    padding: 20px;
                    display: flex;
                    align-items: center;
                    gap: 18px;
                    border: 1px solid #e2e8f0;
                    box-shadow: 0 2px 6px rgba(0,0,0,0.04);
                    cursor: pointer;
                    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                    height: 100%;
                    border: 1px solid #334155 !important;
                }
                
                .user-management-card:hover {
                    transform: translateY(-4px);
                    box-shadow: 0 12px 24px -8px rgba(0,0,0,0.12);
                    border-color: #cbd5e1;
                }
                
                .um-icon-wrapper {
                    width: 56px;
                    height: 56px;
                    border-radius: 14px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-shrink: 0;
                    transition: transform 0.2s;
                }
                
                .user-management-card:hover .um-icon-wrapper {
                    transform: scale(1.05);
                }
                
                .um-text-wrapper {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    gap: 4px;
                }
                
                .um-title {
                    margin: 0;
                    font-size: 1.1rem;
                    font-weight: 700;
                    color: #1e293b;
                    letter-spacing: -0.2px;
                }
                
                .um-subtitle {
                    margin: 0;
                    font-size: 0.8rem;
                    font-weight: 500;
                    color: #64748b;
                    line-height: 1.3;
                }
                
                .um-arrow {
                    color: #cbd5e1;
                    transition: transform 0.2s, color 0.2s;
                }
                
                .user-management-card:hover .um-arrow {
                    color: #3b82f6;
                    transform: translateX(4px);
                }


                /* Dashboard Card Styles */
                .dash-card { background: white; border-radius: 20px; cursor: pointer; transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1); border: 1px solid #334155 !important; position: relative; overflow: hidden; box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03); }
                .main-card:hover { transform: translateY(-8px); box-shadow: 0 20px 35px -12px rgba(0, 0, 0, 0.15); border-color: #e0e7ff; }
                .main-card:hover .icon-wrapper { transform: scale(1.1); }
                .main-card { padding: 28px 16px; display: flex; flex-direction: column; align-items: center; text-align: center; height: 100%; }
                .icon-wrapper { width: 68px; height: 68px; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin-bottom: 18px; transition: transform 0.3s ease, box-shadow 0.3s ease; }
                .card-title { font-size: 16px; font-weight: 700; color: #1e293b; margin: 0; letter-spacing: -0.2px; }
                .card-subtitle { font-size: 12px; color: #64748b; font-weight: 500; margin-top: 4px; }

                /* Voter Search Card */
                .voter-search-card { background: white; display: flex; align-items: center; gap: 18px; cursor: pointer; transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1); }
                .voter-search-card:hover { transform: translateY(-4px); box-shadow: 0 12px 24px -8px rgba(0,0,0,0.12) !important;  border: 1px solid #334155 !important;}
                .voter-icon-circle { width: 56px; height: 56px; border-radius: 28px; background: #eff6ff; display: flex; align-items: center; justify-content: center; color: #3b82f6; flex-shrink: 0; }
                .voter-text { flex: 1; }
                .voter-text h3 { font-size: 1.2rem; font-weight: 700; color: #0f172a; margin: 0 0 4px 0; }
                .voter-text p { font-size: 0.85rem; color: #64748b; margin: 0; }
                .arrow-icon { color: #cbd5e1; transition: transform 0.2s; }
                .voter-search-card:hover .arrow-icon { transform: translateX(6px); color: #3b82f6; }

                .combined-row {
                    padding: 16px;
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    transition: background 0.2s;
                    flex: 1;
                    gap: 12px;
                }
                .list-icon {
                    font-size: 1.4rem;
                    display: flex;
                    align-items: center;
                    flex-shrink: 0;
                }
                .list-title {
                    flex: 1;
                    font-weight: 600;
                    color: #334155;
                    font-size: 1rem;
                }
                .list-count {
                    font-size: 1rem;
                    font-weight: 800;
                    color: #ca8a04;
                    background: #fef3c7;
                    padding: 4px 12px;
                    border-radius: 20px;
                    min-width: 45px;
                    text-align: center;
                    display: inline-block;
                }
                .list-arrow {
                    color: #cbd5e1;
                    transition: color 0.2s;
                    flex-shrink: 0;
                }
                .combined-row:hover .list-arrow {
                    color: #64748b;
                }
                .combined-row:hover .list-count {
                    background: #fde68a;
                    transform: scale(1.05);
                }

                /* Mobile Responsive - Show all options in one row */

                @media (max-width: 768px) {
                    .info-card-content { flex-direction: column; align-items: stretch; gap: 16px; }
                    .info-divider { width: 100%; height: 1px; }
                    .info-item { align-items: center; text-align: center; }
                    .info-value-group { justify-content: center; }
                    .info-number-large { font-size: 1.4rem; }
                    .voter-search-card { flex-wrap: wrap; 
                    .voter-icon-circle { width: 44px; height: 44px; margin-right: 12px; }
                    .voter-icon-circle svg { width: 22px; height: 22px; }
                    .voter-text h3 { font-size: 1rem; }
                    .voter-text p { font-size: 0.75rem; }
                    .voter-count-display { margin-left: auto; margin-right: 12px; padding: 4px 12px; }
                    .voter-count-number { font-size: 1rem; }
                    .arrow-icon svg { width: 20px; height: 20px; }
                    .modern-report-card { padding: 16px; }
                    .user-management-card { padding: 16px; gap: 12px; }
                    .um-icon-wrapper { width: 48px; height: 48px; }
                    .um-title { font-size: 1rem; }
                    
                    /* Force all report cards in Slip & Survey to show in single column */
                    .report-row > div,
                    .social-row > div,
                    .user-row > div {
                        flex: 0 0 100%;
                        max-width: 100%;
                    }
                }
                
                @media (max-width: 480px) {
                    .info-card { padding: 16px; }
                    .info-number { font-size: 1rem; }
                    .info-name { font-size: 0.95rem; }
                    .info-number-large { font-size: 1.2rem; }
                    .voter-search-card { flex-wrap: wrap; gap: 10px; }
                    .voter-icon-circle { width: 38px; height: 38px; margin-right: 10px; }
                    .voter-icon-circle svg { width: 18px; height: 18px; }
                    .voter-text h3 { font-size: 0.9rem; }
                    .voter-text p { font-size: 0.7rem; }
                    .voter-count-display { margin: 0; justify-content: center; order: 3; }
                    .arrow-icon { order: 4; }
                    .arrow-icon svg { width: 18px; height: 18px; }
                    .user-management-card { padding: 14px; gap: 10px; flex-wrap: wrap; }
                    .um-icon-wrapper { width: 44px; height: 44px; }
                    .um-title { font-size: 0.9rem; }
                    .um-subtitle { font-size: 0.7rem; }
                    
                    /* Force all report cards to take full width */
                    .report-row > div,
                    .social-row > div,
                    .user-row > div {
                        flex: 0 0 100%;
                        max-width: 100%;
                    }
                }

                /* Call Center Stats Cards */
.stats-container-callcenter {
    display: flex;
    gap: 16px;
    flex-wrap: wrap;
    margin-bottom: 24px;
}
.stat-card-callcenter {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 16px;
    background: white;
    padding: 20px 24px;
    border-radius: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    border: 1px solid #e2e8f0;
    transition: all 0.2s ease;
    min-width: 180px;
}
.stat-card-callcenter:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.1);
}
.total-booth-card {
    border-left: 4px solid #3b82f6;
}
.total-voter-card {
    border-left: 4px solid #8b5cf6;
}
.total-survey-card {
    border-left: 4px solid #10b981;
}
.today-survey-card {
    border-left: 4px solid #f59e0b;
}
.stat-icon-callcenter {
    font-size: 32px;
}
.stat-info-callcenter {
    display: flex;
    flex-direction: column;
}
.stat-label-callcenter {
    font-size: 12px;
    font-weight: 600;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}
.stat-value-callcenter {
    font-size: 28px;
    font-weight: 800;
    color: #0f172a;
    line-height: 1.2;
}
.total-booth-card .stat-value-callcenter {
    color: #3b82f6;
}
.total-voter-card .stat-value-callcenter {
    color: #8b5cf6;
}
.total-survey-card .stat-value-callcenter {
    color: #10b981;
}
.today-survey-card .stat-value-callcenter {
    color: #f59e0b;
}

@media (max-width: 768px) {
    .stats-container-callcenter {
        flex-direction: column;
        gap: 12px;
    }
    .stat-card-callcenter {
        padding: 16px 20px;
        min-width: auto;
    }
    .stat-value-callcenter {
        font-size: 24px;
    }
    .stat-icon-callcenter {
        font-size: 28px;
    }
}

/* My Booth Section Styles */
.my-booth-section {
    width: 100%;
}
.booth-tags-container {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
}
.booth-tag {
    background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
    color: #1d4ed8;
    padding: 8px 20px;
    border-radius: 30px;
    font-size: 14px;
    font-weight: 700;
    border: 1px solid #bfdbfe;
    transition: all 0.2s ease;
    cursor: default;
}
.booth-tag:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(37, 99, 235, 0.15);
    background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
}

@media (max-width: 640px) {
    .booth-tag {
        padding: 6px 14px;
        font-size: 12px;
    }
}

/* My Booth Section Styles - Square Cards */
.my-booth-section {
    width: 100%;
}
.booth-cards-container {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
}
.booth-square-card {
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 16px 20px;
    min-width: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    transition: all 0.2s ease;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    cursor: default;
}
.booth-square-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 16px -4px rgba(0, 0, 0, 0.1);
    border-color: #cbd5e1;
}
.booth-card-icon {
    font-size: 28px;
}
.booth-card-number {
    font-size: 18px;
    font-weight: 800;
    color: #1e293b;
    text-align: center;
}

@media (max-width: 640px) {
    .booth-square-card {
        min-width: 80px;
        padding: 12px 16px;
    }
    .booth-card-icon {
        font-size: 22px;
    }
    .booth-card-number {
        font-size: 15px;
    }
    .booth-cards-container {
        gap: 12px;
    }
}



/* Live Voting Card Styles */
.lv-card {
    background: #ffffff;
    border-radius: 12px;
    border: 1px solid #475569;
    padding: 20px 16px;
    text-align: center;
    box-shadow: 0 2px 8px rgba(0,0,0,0.04);
    display: flex;
    flex-direction: column;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    height: 100%;
}
.lv-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 16px rgba(0,0,0,0.08);
}

.lv-booth-title {
    color: #1e3a8a;
    font-weight: 800;
    font-size: 18px;
    margin: 0 0 16px 0;
    letter-spacing: 0.5px;
}

.lv-stats-row {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 20px;
}
.lv-stat-box {
    flex: 1;
    padding: 8px;
    border-radius: 8px;
    background: #ffffff;
    font-weight: 700;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.done-box {
    border: 1.5px solid #16a34a;
    color: #16a34a;
}
.remain-box {
    border: 1.5px solid #b91c1c;
    color: #b91c1c;
}

.lv-add-btn {
    width: 100%;
    background: #1e3a8a;
    color: #ffffff;
    border: none;
    border-radius: 8px;
    padding: 12px;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    transition: background 0.2s ease;
}
.lv-add-btn:hover {
    background: #1e40af;
}

@media (max-width: 768px) {
    .lv-booth-title {
        font-size: 16px;
    }
    .lv-stat-box {
        font-size: 12px;
        padding: 6px;
    }
    .lv-add-btn {
        padding: 10px;
        font-size: 13px;
    }
}
    /* Modal Styles for My Booth Section */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 20px;
}
.modal-content {
    background: white;
    border-radius: 16px;
    width: 100%;
    max-width: 500px;
    max-height: 80vh;
    overflow-y: auto;
    box-shadow: 0 20px 35px -10px rgba(0, 0, 0, 0.3);
    animation: modalSlideIn 0.3s ease;
}
@keyframes modalSlideIn {
    from {
        opacity: 0;
        transform: scale(0.95);
    }
    to {
        opacity: 1;
        transform: scale(1);
    }
}
.modal-header {
    padding: 20px 24px;
    border-bottom: 1px solid #e2e8f0;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.modal-header h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 700;
    color: #1e293b;
}
.modal-close-btn {
    background: none;
    border: none;
    font-size: 28px;
    cursor: pointer;
    color: #94a3b8;
    transition: color 0.2s;
}
.modal-close-btn:hover {
    color: #1e293b;
}
.modal-body {
    padding: 24px;
}
.input-group {
    margin-bottom: 24px;
}
.input-group label {
    display: block;
    font-size: 14px;
    font-weight: 600;
    color: #1e293b;
    margin-bottom: 8px;
}
.add-number-container {
    display: flex;
    gap: 12px;
}
.number-input {
    flex: 1;
    padding: 12px 16px;
    border: 1px solid #cbd5e1;
    border-radius: 10px;
    font-size: 14px;
    outline: none;
    transition: all 0.2s;
}
.number-input:focus {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.add-number-btn {
    padding: 12px 20px;
    background: #3b82f6;
    color: white;
    border: none;
    border-radius: 10px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s;
}
.add-number-btn:hover {
    background: #2563eb;
}
.numbers-list label {
    display: block;
    font-size: 14px;
    font-weight: 600;
    color: #1e293b;
    margin-bottom: 12px;
}
.numbers-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    max-height: 250px;
    overflow-y: auto;
}
.number-tag {
    display: flex;
    align-items: center;
    gap: 8px;
    background: #f1f5f9;
    padding: 8px 12px;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
}
.number-tag span {
    font-size: 14px;
    font-weight: 600;
    color: #1e293b;
}
.remove-number {
    background: none;
    border: none;
    font-size: 18px;
    cursor: pointer;
    color: #ef4444;
    padding: 0 4px;
    transition: color 0.2s;
}
.remove-number:hover {
    color: #dc2626;
}
.no-numbers {
    text-align: center;
    padding: 20px;
    color: #94a3b8;
    font-size: 14px;
}
.modal-footer {
    padding: 16px 24px;
    border-top: 1px solid #e2e8f0;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
}
.cancel-btn {
    padding: 10px 20px;
    background: #f1f5f9;
    color: #475569;
    border: none;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s;
}
.cancel-btn:hover {
    background: #e2e8f0;
}
.submit-btn {
    padding: 10px 24px;
    background: #10b981;
    color: white;
    border: none;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s;
}
.submit-btn:hover:not(:disabled) {
    background: #059669;
}
.submit-btn:disabled {
    background: #94a3b8;
    cursor: not-allowed;
}

            `}</style>

        </div>

    );

};


// Live Voting Card Component
const LiveVotingCard = ({ booth, appId, userId, txt, navigate }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedBooth, setSelectedBooth] = useState(null);
    const [voterNumber, setVoterNumber] = useState("");
    const [voterNumbersList, setVoterNumbersList] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const BASE_URL = process.env.REACT_APP_BASE_URL;

    const handleCardClick = (boothNumber) => {
        navigate('/dis_booth_wise_live_voting_voter', { state: { boothNo: boothNumber } });
    };

    const handleAddVoting = (boothNumber, e) => {
        e.stopPropagation();
        setSelectedBooth(boothNumber);
        setVoterNumber("");
        setVoterNumbersList([]);
        setIsModalOpen(true);
    };

    const handleAddNumber = () => {
        if (voterNumber && voterNumber.trim()) {
            setVoterNumbersList([...voterNumbersList, voterNumber.trim()]);
            setVoterNumber("");
        }
    };

    const handleRemoveNumber = (index) => {
        const updatedList = voterNumbersList.filter((_, i) => i !== index);
        setVoterNumbersList(updatedList);
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleAddNumber();
        }
    };

    const handleSubmit = async () => {
        if (voterNumbersList.length === 0) {
            alert("Please add at least one voter number");
            return;
        }

        const jsonRowsArray = voterNumbersList.map(number => ({
            app_id: String(appId),
            slnoinpart: number,
            part_no: String(selectedBooth)
        }));

        const jsonRowsString = JSON.stringify(jsonRowsArray);

        setIsSubmitting(true);

        try {
            const response = await axios.post(`${BASE_URL}/api/ins_live_voting_bulk`, {
                app_id: appId,
                json_rows: jsonRowsString,
                created_by: String(userId)
            });

            if (response.data.success) {
                alert(txt.successMessage || "Voting data submitted successfully!");
                setIsModalOpen(false);
                setVoterNumbersList([]);
                setVoterNumber("");
            } else {
                alert("Failed to submit voting data.");
            }
        } catch (error) {
            console.error("Error submitting voting data:", error);
            alert("Error submitting voting data.");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="col-12 col-sm-6 col-md-4 col-lg-3">
            <div className="lv-card" onClick={() => handleCardClick(booth)} style={{ cursor: 'pointer' }}>
                <h3 className="lv-booth-title">
                    {txt.booth || "Booth"} : {booth}
                </h3>
                <div className="lv-stats-row">
                    <div className="lv-stat-box done-box">
                        <span>{txt.done || "Done"}</span>
                    </div>
                    <div className="lv-stat-box remain-box">
                        <span>{txt.remain || "Remain"}</span>
                    </div>
                </div>
                <button
                    className="lv-add-btn"
                    onClick={(e) => handleAddVoting(booth, e)}
                >
                    {txt.addVoting || "Add Voting"}
                </button>
            </div>

            {/* Modal Popup */}
            {isModalOpen && (
                <div className="modal-overlay" onClick={() => setIsModalOpen(false)}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h3>{txt.modalTitle || "Add Voter Numbers"} - {txt.booth || "Booth"} {selectedBooth}</h3>
                            <button className="modal-close-btn" onClick={() => setIsModalOpen(false)}>×</button>
                        </div>

                        <div className="modal-body">
                            <div className="input-group">
                                <label>{txt.enterNumber || "Enter Voter Number"}</label>
                                <div className="add-number-container">
                                    <input
                                        type="text"
                                        value={voterNumber}
                                        onChange={(e) => setVoterNumber(e.target.value)}
                                        onKeyPress={handleKeyPress}
                                        placeholder="Enter serial number..."
                                        className="number-input"
                                    />
                                    <button
                                        className="add-number-btn"
                                        onClick={handleAddNumber}
                                    >
                                        {txt.addNumber || "Add Number"}
                                    </button>
                                </div>
                            </div>

                            <div className="numbers-list">
                                <label>{txt.addedNumbers || "Added Numbers"}</label>
                                {voterNumbersList.length > 0 ? (
                                    <div className="numbers-grid">
                                        {voterNumbersList.map((num, idx) => (
                                            <div key={idx} className="number-tag">
                                                <span>{num}</span>
                                                <button
                                                    className="remove-number"
                                                    onClick={() => handleRemoveNumber(idx)}
                                                >
                                                    ×
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    <p className="no-numbers">{txt.noNumbers || "No numbers added yet"}</p>
                                )}
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button className="cancel-btn" onClick={() => setIsModalOpen(false)}>
                                {txt.cancel || "Cancel"}
                            </button>
                            <button
                                className="submit-btn"
                                onClick={handleSubmit}
                                disabled={isSubmitting || voterNumbersList.length === 0}
                            >                                {isSubmitting ? "Submitting..." : (txt.submit || "Submit")}
                            </button>
                        </div>
                    </div>
                </div>
            )}        </div>
    );
};
// --- Helper Components ---
const HorizontalFeatureCard = ({ title, subtitle, icon, iconBgColor, subtitleColor, onClick, delay }) => (
    <div className="col-12 col-md-6 fade-in-up" style={{ animationDelay: delay }}>
        <div className="horizontal-feature-card" onClick={onClick}>
            <div className="hf-icon-wrapper" style={{ backgroundColor: iconBgColor }}>{icon}</div>
            <div className="hf-text-wrapper">
                <h3 className="hf-title">{title}</h3>
                <span className="hf-subtitle" style={{ color: subtitleColor, borderBottomColor: "white" }}>{subtitle}</span>
            </div>
        </div>
    </div>
);

const DashboardCard = ({ title, subtitle, icon, color, onClick, delay }) => (
    <div className="col-6 col-md-4 col-lg-2 fade-in-up mt-2 mb-2" style={{ animationDelay: delay }}>
        <div className="dash-card main-card h-100" onClick={onClick} style={{ '--hover-color': color }}>
            <div className="icon-wrapper" style={{ backgroundColor: `${color}15`, color: color }}>{icon}</div>
            <h3 className="card-title">{title}</h3>
            {subtitle && <span className="card-subtitle">{subtitle}</span>}
        </div>
    </div>
);

const Dashboard_card = ({ title, subtitle, icon, color, onClick, delay }) => (
    <div className="col-6 col-md-4 col-lg-4 fade-in-up" style={{ animationDelay: delay }}>
        <div className="dash-card main-card h-100" onClick={onClick} style={{ '--hover-color': color }}>
            <div className="icon-wrapper" style={{ backgroundColor: `${color}15`, color: color }}>{icon}</div>
            <h3 className="card-title">{title}</h3>
            {subtitle && <span className="card-subtitle">{subtitle}</span>}
        </div>
    </div>
);

const ModernReportCard = ({ title, subtitle, icon, color, onClick, delay }) => (
    <div className="col-12 col-md-6 col-lg-4 fade-in-up mt-2 mb-2" style={{ animationDelay: delay }}>
        <div className="modern-report-card" onClick={onClick}>
            <div className="mr-icon-box" style={{ backgroundColor: `${color}1a`, color: color }}>{icon}</div>
            <div className="mr-text-box">
                <h5 className="mr-title">{title}</h5>
                {subtitle && <p className="mr-subtitle">{subtitle}</p>}
            </div>
        </div>
    </div>
);

const CombinedDashboardCard = ({ title1, count1, icon1, onClick1, title2, count2, icon2, onClick2, delay }) => (
    <div className="col-12 col-md-6 col-lg-4 fade-in-up mt-2 mb-2" style={{ animationDelay: delay }}>
        <div className="combined-card">
            <div className="combined-row" onClick={onClick1}>
                <span className="list-icon">{icon1}</span>
                <span className="list-title">{title1}</span>
                <span className="list-count">{count1}</span>
                <svg className="list-arrow" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                </svg>
            </div>
            <div className="combined-divider"></div>
            <div className="combined-row" onClick={onClick2}>
                <span className="list-icon">{icon2}</span>
                <span className="list-title">{title2}</span>
                <span className="list-count">{count2}</span>
                <svg className="list-arrow" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                </svg>
            </div>
        </div>
    </div>
);

// --- Custom SVG Icons ---
const ThreePeopleIcon = ({ color }) => (
    <svg width="28" height="28" viewBox="0 0 24 24" fill={color}>
        <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
        <path d="M12 13c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
    </svg>
);

const MultiPeopleIcon = () => (
    <svg width="28" height="28" viewBox="0 0 24 24">
        <path fill="#94a3b8" d="M8 11c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5z" />
        <path fill="#7dd3fc" d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm0 2c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
        <path fill="#e11d48" d="M12 13c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
    </svg>
);

const UserGearIcon = () => <svg width="28" height="28" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" /><path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /></svg>;
const UserGroupIcon = () => <svg width="28" height="28" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" /></svg>;
const BuildingIcon = () => <svg width="28" height="28" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" /></svg>;
const BoothIcon = () => <svg width="28" height="28" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z" /></svg>;
const VolunteerIcon = () => <svg width="28" height="28" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" /></svg>;
const HeadsetIcon = () => <svg width="28" height="28" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z" /></svg>;
const ReportIcon = () => <svg width="28" height="28" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" /></svg>;
const SurveyIcon = () => <svg width="28" height="28" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>;
const HeadsetReportIcon = () => <svg width="28" height="28" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" /></svg>;
const GiftIcon = () => <svg width="28" height="28" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 8h14a1 1 0 011 1v3a1 1 0 01-1 1H5a1 1 0 01-1-1V9a1 1 0 011-1z" /></svg>;
const ChartBarIcon = () => <svg width="28" height="28" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M18 20V10M12 20V4M6 20v-6" /></svg>;
export default Dashboard;